<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import { GoogleMap, Marker } from "vue3-google-map";
import DropZone from "@/components/widgets/dropZone";
import {ref} from "vue";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Empresa",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loader, Multiselect, GoogleMap, Marker, DropZone },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    return { dropzoneFile, drop, v$: useVuelidate()};
  },
  data() {
    return {
      showFormRegraFrete: false,
      submittedRegraFrete: false,
      regrasFretesData: null,
      regraFreteData: {},


      showFormOrigem: false,
      emprOrigensData: null,
      emprOrigemData: {},
      submittedEmprOrigem: false,

      showFormEmprParam: false,
      emprParamsData: null,
      emprParamData: {},
      submittedEmprParam: false,

      loadingEmprTokemData: false,

      emprSegtoData: {},
      emprSegtosData: null,
      submittedEmprSegto: false,
      showFormSegtoFrete: false,

      showModalSlaEntrega: false,
      showModalSlaEntregaCidade: false,
      slaentregaData: null,
      slaentregacidadesData: null,
      slaentrega: {
        diassla: 0,
        diasuteis: "CORRIDOS"
      },
      slaentregacidade: {},
      cidadesData: null,
      cidadesTratadoData: null,
      submittedSlaEntrega: false,
      cidadeSelecionadaSLA: null,
      cidadeSelecionadaSLAData: null,
      cidadesDataSLA: [],
      cidadesAdicionar: [],
      
      empreTokensData: null,
      empreTokemData: {},
      showFormToken: false,

      showFormEquivalence: false,
      showFormEquivalenceToken: false,
      equivalenceTokens: [],
      equivalenceEditing: {},
      
      showHubSelectionModal: false,
      selectedHubClass: null,
      pendingHubAction: null,
      
      showModalWmsEndereco: false,
      loadingWmsEndereco: false,
      dtListPesqWmsEndereco: null,
      wmsEnderecoSel: null,
      wmsEnderecosData: null,

      cotaFreteListData: {},
      freteCotaData: {},
      dtListPesqFreteCota: null,

      showModalAtuLogo: false,
      tipoUpload: 'white',
      blobUrlWhite: null,
      blobUrlBlack: null,
      blobUrlDanfe: null,
      blobUrl: null,
      dataUrl: null,

      submittedAnexo: false,
      mediasData: {},
      showModalEndereco: false,
      markers: null,

      showModalCertDigital: false,
      empreCertDigList: [],
      empreCertDigData: {
        id: null,
        tipo: 'A1',
        senha: null,
        validade: null,
      },

      markerOptions: null,

      dtListPesqCidade: null,

      showModalConsCEP: false,
      loadingDadosCep: false,

      consCnpjImpNome: true,
      consCnpjImpFantasia: true,
      consCnpjImpEndereco: true,
      consCnpjImpNumero: true,
      consCnpjImpBairro: true,
      consCnpjImpUf: true,
      consCnpjImpCep: true,
      consCnpjImpEmail: true,
      consCnpjImpTel: true,
      consCnpjImpCnpj: true,
      consCnpjImpCompl: true,
      consCnpjImpCidade: true,
      consCnpjImpEstado: true,

      consCnpjSituacao: '',
      consCnpjDAbe: '',
      consCnpjSocio1: '',
      consCnpjSocio2: '',

      consCnpjNome: '',
      consCnpjFantasia: '',
      consCnpjEndereco: '',
      consCnpjNumero: '',
      consCnpjMunic: '',
      consCnpjBairro: '',
      consCnpjUf: '',
      consCnpjCep: '',
      consCnpjEmail: '',
      consCnpjTel: '',
      consCnpjCnpj: '',
      consCnpjCompl: '',
      consCnpjCidade: '',
      consCnpjEstado: '',


      loadingDadosCnpj: false,
      loadingDadosCnpjTomador: false,
      loadingRegras: false,
      submitNatuRegra: false,
      showModalConsCNPJ: false,
      errosValid: [],
      emprePermisData: {},
      loadingEmpresa: false,
      empresaData: {
        id: 0,
        status: 'A',
        redfinconf: false,
        editvolfinconf: false,
        naturezapadrao: "",
      },
      empreRegrasData: null,
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,
      paramTomador: null,

      empresaDatas: {
        avisentr: []
      },

      opcoesAvisos: [
        { value: '' },
        { text: 'Romaneio e Entrega', value: 'ROMENT' },
        { text: 'Entrada de CTE', value: 'ENTCTE' },
        { text: 'Entrada de NF', value: 'ENTNF' },
        { text: 'Entrega Finalizada', value: 'ENTFNL' }
      ],

      title: "Editar Empresa",
      items: [
        {
          text: "Empresas",
          href: "/empresas/list",
        },
        {
          text: "Editar Empresa",
          active: true,
        },
      ],

      showModalLogoCobranca: false,
      emprparamcobranca: {
        pessoafisicperc: 0,
        pessoajuricperc: 0,
        cobrantec: 1,
        qtddiasantec: 0,
        cobrvencida: 0,
        qtdcobrvencida: 0,
        meio_cobranca:'E'
      },

      showModalHelp: false,
      dtListHelp: [],

      checkboxNatureza: false,
      naturezasList: [],
      empreTokenHubs: [
          { value: "ACX", label: "Acerta Express", classe: "transp" },
          { value: "ALLPOST", label: "All Post", classe: "transp" },
          { value: "AMAZON", label: "Amazon", classe: "marketplace" },
          { value: "ANJUN", label: "Anjun Express", classe: "transp" },
          { value: "ANYMARKET", label: "Any Market", classe: "marketplace" },
          { value: "ALFA", label: "Alfa", classe: "transp" },
          { value: "AZLCRG", label: "Azul Cargo", classe: "transp" },
          { value: "BERTOLINI", label: "Bertolini", classe: "transp" },
          { value: "B2WNOVA", label: "B2W Nova Api", classe: "marketplace" },
          { value: "BLING", label: "Bling", classe: "erp" },
          { value: "BRP", label: "Braspres Rastreio", classe: "transp" },
          { value: "BRPCOTA", label: "Braspres Cotação", classe: "transp" },
          { value: "BRUDAM", label: "Brudam", classe: "transp" },
          { value: "CORREIOS", label: "Correios", classe: "transp" },
          { value: "ESLC", label: "ESL Cloud", classe: "tms" },
          { value: "ESLD", label: "ESL Desktop", classe: "tms" },
          { value: "ESM", label: "Expresso São Miguel", classe: "transp" },
          { value: "FOCUSNFE", label: "Focus NFe", classe: "erp" },
          { value: "JAMEF", label: "Jamef", classe: "transp" },
          { value: "JDL", label: "JadLog", classe: "transp" },
          { value: "JET", label: "J&T Express", classe: "transp" },
          { value: "LEROYMER", label: "Leroy Merlin", classe: "marketplace" },
          { value: "LOGGI", label: "Loggi", classe: "transp" },
          { value: "LOGMED", label: "Logmed", classe: "transp" },
          { value: "LJTO", label: "LogJato", classe: "transp" },
          { value: "LOJAMEC", label: "Loja do Mecânico", classe: "marketplace" },
          { value: "MAGALU", label: "Magazine Luiza", classe: "marketplace" },
          { value: "MANDAE", label: "Mandaê", classe: "transp" },
          { value: "MIRA", label: "Mira", classe: "transp" },
          { value: "MOBILE", label: "Mobile", classe: "transp" },
          { value: "MOVVI", label: "Movvi", classe: "transp" },
          { value: "MODULAR", label: "Modular", classe: "transp" },
          { value: "NOTAZZ", label: "Notazz", classe: "erp" },
          { value: "OCO", label: "OCOREN", classe: "transp" },
          { value: "OURNGR", label: "Ouro Negro LTDA", classe: "transp" },
          { value: "OURPRT", label: "Ouro Preto Transportes", classe: "transp" },
          { value: "PAGBANKAPI", label: "PagBank API", classe: "bancaria" },
          { value: "PAGBANKEDI", label: "PagBank EDI", classe: "bancaria" },
          { value: "QLTY", label: "Quality", classe: "transp" },
          { value: "PATR", label: "Patrus", classe: "transp" },
          { value: "RBEXP", label: "RB Express", classe: "transp" },
          { value: "RDV", label: "Rodonavis", classe: "transp" },
          { value: "RELM", label: "Realmed", classe: "transp" },
          { value: "SPCBRASILCONSULTA", label: "SPC Brasil Consulta", classe: "erp" },
          { value: "SPCBRASILINCLUSAOEXCLUSAO", label: "SPC Brasil Inclusão/Exclusão", classe: "erp" },
          { value: "SHOPEETRK", label: "Shopee Rastreio", classe: "marketplace" },
          { value: "SICOOB", label: "Sicoob", classe: "bancaria" },
          { value: "SKYHUB", label: "SkyHub", classe: "marketplace" },
          { value: "SOL", label: "Solistica", classe: "transp" },
          { value: "SSW", label: "SSW", classe: "transp" },
          { value: "SSWCOTA", label: "SSW Cotação", classe: "transp" },
          { value: "TECMAR", label: "Tecmar", classe: "transp" },
          { value: "TINY", label: "Tiny", classe: "erp" },
          { value: "TRAY", label: "Tray", classe: "marketplace" },
          { value: "TRAYCORP", label: "TrayCorp", classe: "marketplace" },
          { value: "TNT", label: "TNT", classe: "transp" },
          { value: "TOTEXP", label: "TOTEXP", classe: "transp" },
          { value: "TOTAL", label: "TOTAL", classe: "transp" },
          { value: "TRCO", label: "Transcourier", classe: "transp" },
          { value: "TRV", label: "Translovato", classe: "transp" },
          { value: "YAPAY", label: "Vindi", classe: "bancaria" },
          { value: "VTEX", label: "Vtex", classe: "marketplace" },
          { value: "SPC", label: "SPC", classe: "erp" }
        ],
      emprfiscalData: {
        im: '',
        ind_icms: '',
        ind_ipi: '',
        regime_pis_cofins: '',
        cst_icms_padrao: '',
        aliq_icms_padrao: 0,
        fcp_icms_padrao: 0,
        mva_icms_padrao: 0,
        ctrl_ciap: false,
        perc_prop_icms: 0,
        perc_ciap_mes: 0,
        cst_ipi_padrao: '',
        cst_pis_saida: '',
        aliq_pis_saida: 0,
        cst_pis_ent: '',
        cst_cofins_saida: '',
        aliq_cofins_saida: 0,
        cst_cofins_ent: '',
        aliq_issqn_padrao: 0,
        cod_servico_padrao: '',
        local_issqn_padrao: '',
        contador_nome: '',
        contador_cpf: '',
        contador_crc: '',
        contador_email: '',
        gerar_bloco_k: false,
        gerar_bloco_g: false,
        gerar_bloco_m: false,
        gerar_bloco_c: false,
        serie_nfe_padrao: '',
        tp_emis_padrao: '',
        email_alertas_nfe: '',
        ativadoambprod: false,
        modelo: 55,
        ultimanotahmg: 0,
        ultimanotaprod: 0
      }
    };
  },

  computed: {
    filteredHubs() {
      if (this.showFormToken) {
        return this.empreTokenHubs.filter(h => h.classe === this.empreTokemData.hub_class);
      }
      if (this.showFormEquivalence) {
        return this.empreTokenHubs.filter(h => h.classe === this.empreTokemData.hub_class);
      }
      return this.empreTokenHubs;
    },
    previewInstrucoesBoletoPJ() {
        if (!this.empreTokemData.instrucoes_boleto_pj) return '';
        const juros = this.empreTokemData.juros || '0,00';
        const multapj = this.empreTokemData.multapj || '0,00';
        const desconto = this.empreTokemData.desconto || '0,00';

        return this.empreTokemData.instrucoes_boleto_pj.split(';').map(m => {
             return m.replace('[$juros]', juros)
                     .replace('[$multa]', multapj)
                     .replace('[$desconto]', desconto);
        }).join(';<br>');
    },
    previewInstrucoesBoletoPF() {
        if (!this.empreTokemData.instrucoes_boleto_pf) return '';
        const juros = this.empreTokemData.juros || '0,00';
        const multapf = this.empreTokemData.multapf || '0,00';
        const desconto = this.empreTokemData.desconto || '0,00';

        return this.empreTokemData.instrucoes_boleto_pf.split(';').map(m => {
             return m.replace('[$juros]', juros)
                     .replace('[$multa]', multapf)
                     .replace('[$desconto]', desconto);
        }).join(';<br>');
    },
    instrucoesBoletoPJDisplay: {
      get() {
        if (!this.empreTokemData.instrucoes_boleto_pj) return '';
        const clean = this.empreTokemData.instrucoes_boleto_pj.replace(/;/g, '').trim();
        if (clean === '') return '';
        return this.empreTokemData.instrucoes_boleto_pj.split(';').join('\n');
      },
      set(newValue) {
        const lines = newValue.split('\n');
        let hasError = false;
        const truncatedLines = lines.map(line => {
            if (line.length > 40) {
                hasError = true;
                return line.substring(0, 40);
            }
            return line;
        });

        if (hasError) {
             Swal.fire({
                position: "center",
                icon: "warning",
                title: "Limite de Caracteres",
                text: "O campo Mensagens de Instruções (PJ) permite adicionar até 5 mensagens, com no máximo 40 caracteres.",
                showConfirmButton: true
            });
        }
        this.empreTokemData.instrucoes_boleto_pj = truncatedLines.join(';');
      }
    },
    instrucoesBoletoPFDisplay: {
      get() {
        if (!this.empreTokemData.instrucoes_boleto_pf) return '';
        const clean = this.empreTokemData.instrucoes_boleto_pf.replace(/;/g, '').trim();
        if (clean === '') return '';
        return this.empreTokemData.instrucoes_boleto_pf.split(';').join('\n');
      },
      set(newValue) {
        const lines = newValue.split('\n');
        let hasError = false;
        const truncatedLines = lines.map(line => {
            if (line.length > 40) {
                hasError = true;
                return line.substring(0, 40);
            }
            return line;
        });

        if (hasError) {
             Swal.fire({
                position: "center",
                icon: "warning",
                title: "Limite de Caracteres",
                text: "O campo Mensagens de Instruções (PF) permite adicionar até 5 mensagens, com no máximo 40 caracteres.",
                showConfirmButton: true
            });
        }
        this.empreTokemData.instrucoes_boleto_pf = truncatedLines.join(';');
      }
    },
    previewInstrucoesBoletoEquivalencePJ() {
        if (!this.equivalenceEditing.instrucoes_boleto_pj) return '';
        const juros = this.equivalenceEditing.juros || '0,00';
        const multapj = this.equivalenceEditing.multapj || '0,00';
        const desconto = this.equivalenceEditing.desconto || '0,00';

        return this.equivalenceEditing.instrucoes_boleto_pj.split(';').map(m => {
             return m.replace('[$juros]', juros)
                     .replace('[$multa]', multapj)
                     .replace('[$desconto]', desconto);
        }).join(';<br>');
    },
    previewInstrucoesBoletoEquivalencePF() {
        if (!this.equivalenceEditing.instrucoes_boleto_pf) return '';
        const juros = this.equivalenceEditing.juros || '0,00';
        const multapf = this.equivalenceEditing.multapf || '0,00';
        const desconto = this.equivalenceEditing.desconto || '0,00';

        return this.equivalenceEditing.instrucoes_boleto_pf.split(';').map(m => {
             return m.replace('[$juros]', juros)
                     .replace('[$multa]', multapf)
                     .replace('[$desconto]', desconto);
        }).join(';<br>');
    },
    instrucoesBoletoPJDisplayEquivalence: {
      get() {
        if (!this.equivalenceEditing.instrucoes_boleto_pj) return '';
        const clean = this.equivalenceEditing.instrucoes_boleto_pj.replace(/;/g, '').trim();
        if (clean === '') return '';
        return this.equivalenceEditing.instrucoes_boleto_pj.split(';').join('\n');
      },
      set(newValue) {
        const lines = newValue.split('\n');
        let hasError = false;
        const truncatedLines = lines.map(line => {
            if (line.length > 40) {
                hasError = true;
                return line.substring(0, 40);
            }
            return line;
        });

        if (hasError) {
             Swal.fire({
                position: "center",
                icon: "warning",
                title: "Limite de Caracteres",
                text: "O campo Mensagens de Instruções (PJ) permite adicionar até 5 mensagens, com no máximo 40 caracteres.",
                showConfirmButton: true
            });
        }
        this.equivalenceEditing.instrucoes_boleto_pj = truncatedLines.join(';');
      }
    },
    instrucoesBoletoPFDisplayEquivalence: {
      get() {
        if (!this.equivalenceEditing.instrucoes_boleto_pf) return '';
        const clean = this.equivalenceEditing.instrucoes_boleto_pf.replace(/;/g, '').trim();
        if (clean === '') return '';
        return this.equivalenceEditing.instrucoes_boleto_pf.split(';').join('\n');
      },
      set(newValue) {
        const lines = newValue.split('\n');
        let hasError = false;
        const truncatedLines = lines.map(line => {
            if (line.length > 40) {
                hasError = true;
                return line.substring(0, 40);
            }
            return line;
        });

        if (hasError) {
             Swal.fire({
                position: "center",
                icon: "warning",
                title: "Limite de Caracteres",
                text: "O campo Mensagens de Instruções (PF) permite adicionar até 5 mensagens, com no máximo 40 caracteres.",
                showConfirmButton: true
            });
        }
        this.equivalenceEditing.instrucoes_boleto_pf = truncatedLines.join(';');
      }
    },
    hubClassInfo() {
      const hClass = this.showFormToken ? this.empreTokemData.hub_class : ((this.showFormEquivalence || this.showFormEquivalenceToken) ? (this.showFormEquivalence ? this.empreTokemData.hub_class : this.equivalenceEditing.hub_class) : null);
      const info = {
        bancaria: { label: 'Agências Bancárias', icon: 'mdi-bank', color: 'primary', bg: 'bg-primary' },
        transp: { label: 'Credenciais Transportador', icon: 'mdi-truck', color: 'success', bg: 'bg-success' },
        erp: { label: 'ERP Terceiro', icon: 'mdi-application-cog', color: 'info', bg: 'bg-info' },
        marketplace: { label: 'Marketplace', icon: 'mdi-store', color: 'warning', bg: 'bg-warning' },
        tms: { label: 'TMS', icon: 'mdi-routes', color: 'danger', bg: 'bg-danger' }
      };
      return info[hClass] || { label: 'Configuração de Hub', icon: 'mdi-cog', color: 'secondary', bg: 'bg-secondary' };
    }
  },

  watch: {
    'empreTokemData.juros_ativo'() {
      this.updateInstrucoesBoleto();
    },
    'empreTokemData.multapj_ativo'() {
      this.updateInstrucoesBoleto();
    },
    'empreTokemData.multapf_ativo'() {
      this.updateInstrucoesBoleto();
    },
    'empreTokemData.desconto_ativo'() {
      this.updateInstrucoesBoleto();
    },
    'equivalenceEditing.juros_ativo'() {
      this.updateInstrucoesBoletoEquivalence();
    },
    'equivalenceEditing.multapj_ativo'() {
      this.updateInstrucoesBoletoEquivalence();
    },
    'equivalenceEditing.multapf_ativo'() {
      this.updateInstrucoesBoletoEquivalence();
    },
    'equivalenceEditing.desconto_ativo'() {
      this.updateInstrucoesBoletoEquivalence();
    }
  },

  validations: {
    empresaData: {
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      nome: {
        required: helpers.withMessage("Campo nome obrigatório, favor preencher.", required),
      },
      fantasia: {
        required: helpers.withMessage("Campo nome fantasia obrigatório, favor preencher.", required),
      },
      razao: {
        required: helpers.withMessage("Campo razão social obrigatório, favor preencher.", required),
      },
      cnpj: {
        required: helpers.withMessage("Campo CNPJ obrigatório, favor preencher.", required),
      },
    },
  },

  methods: {
    salvaCertDig(cert){
      api.get(`${getBaseUrl()}api/ativacertdig`, {
        params: {
          empresa_id: this.idData,
          cert_id : cert.id
        }
      }).then(res => {
        console.log('then salvar certificado')
        console.log(res.data)

        Swal.fire({
          position: 'top-end',
          icon: res.data.success ? 'success' : 'error',
          title: res.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          this.atualizaPagina()
        })
      })
    },

    salvarRegraEmprFiscal() {
      console.log("salvarRegraEmprFiscal")
      this.updating = true

      // Sanitização de campos com máscara
      const dadosParaSalvar = JSON.parse(JSON.stringify(this.emprfiscalData));
      if (dadosParaSalvar.contador_cpf) {
        dadosParaSalvar.contador_cpf = dadosParaSalvar.contador_cpf.replace(/\D/g, '');
      }

      api.post(`${getBaseUrl()}api/emprfiscal`, {
        empresa_id: this.idData,
        emprfiscalData: dadosParaSalvar
      }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.emprfiscalData = res.data.emprfiscalData
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: res.data.success ? "success" : "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2000
          })

          this.carregarDados()
        })
    },

    escolheuAviso() {
      console.log('Avisos selecionados atualmente:', this.empresaDatas.avisentr);
      const avisosFormatados = this.empresaDatas.avisentr.join(',');
      console.log('String para o back-end:', avisosFormatados);
    },

    mostrarHelp(tipo){
      switch(tipo){
        case 'estoque':
          this.dtListHelp = [
            {
              tipo: "Padrão",
              descricao: 'Cada saída de saldo deve conter saldo disponível para o produto(Validação de saldo disponível)'
            },
            {
              tipo: 'Descritivo',
              descricao: 'Não registra valida saldo disponível ou não, apenas registra entradas e saídas'
            },
            {
              tipo: 'Negativação',
              descricao: 'Registra saldo de negativação de saldo para poder quitar posteriormente com base em entradas posteriores indicadas(ex: dropshipping)'
            }
          ]
          this.showModalHelp = true
          break

        case 'endereco':
          this.dtListHelp = [
            {
              tipo: "empresa",
              descricao: 'Considerar endereços por empresa(mais seguro)'
            },
            {
              tipo: "todos",
              descricao: 'Considerar todos os endereços para todas as empresas(menos seguro)'
            },
          ]
          this.showModalHelp = true
          break

        case 'fluxosaida':
          this.dtListHelp = [
            {
              tipo: "pedido",
              descricao: 'Gerar Pedido após confirmação de orçamento'
            },
            {
              tipo: "OS",
              descricao: 'Gerar separação após confirmação de orçamento'
            },
          ]
          this.showModalHelp = true
          break

        case 'natureza':
          this.dtListHelp = [
            {
              tipo: "natureza",
              descricao: 'Definir natureza padrão para que já esteja definida em pedido.'
            },
          ]
          this.showModalHelp = true
          break

        case "volume":
          this.dtListHelp = [
            {
              tipo: "Manual",
              descricao: 'A criação da volumetria é feita dinamicamente.'
            },
            {
              tipo: "Automático",
              descricao: 'A criação da volumetria é automaticamente, mas sempre 1 volume.'
            },
          ]
          this.showModalHelp = true
          break
      }
    },

    carregarDados() {
      console.log('mounted_empresa_editar_0')
      let rota = this.$route.path
      // console.log(rota)
      let ultimaBarra = rota.lastIndexOf('/')
      if (ultimaBarra){
        this.idData = parseInt(rota.substring(ultimaBarra + 1))
      }
      console.log(`idData: ${this.idData}`)
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/empresa`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            this.empresaData = res.data[0]
            this.empreRegrasData = res.data[1]

            if (res.data[2]){
              this.dtListPesqCidade = [
                {
                  'codigo': res.data[2].codigo,
                  'descricao': res.data[2].descricao
                },
              ]
            }

            if (res.data[3]){
              this.mediasData = res.data[3]
              this.mediasData.forEach((value) => {
                if (value.descricao === "empr01_w.png"){
                  api.get(`${getBaseUrl()}api/getfile`, {
                    responseType: 'blob',
                    params: { pathData: value.path }
                  }).then((res) => {
                    // console.log('baixararq')
                    // console.log(res)
                    this.blobUrlWhite = URL.createObjectURL(res.data)
                  })
                }

                else if (value.descricao === "empr01_b.png"){
                  api.get(`${getBaseUrl()}api/getfile`, {
                    responseType: 'blob',
                    params: { pathData: value.path }
                  }).then((res) => {
                    // console.log('baixararq')
                    // console.log(res)
                    this.blobUrlBlack = URL.createObjectURL(res.data)
                  })
                }

                else if (value.descricao === "empr01_danfe.jpg"){
                  api.get(`${getBaseUrl()}api/getfile`, {
                    responseType: 'blob',
                    params: { pathData: value.path }
                  }).then((res) => {
                    // console.log('baixararq_danfe')
                    // console.log(res)
                    this.blobUrlDanfe = URL.createObjectURL(res.data)
                  })
                }

              });
            }


            if (this.empresaData.latlong){
              const latLong = this.empresaData.latlong
              const posVirg = latLong.indexOf(",");
              const lat =  parseFloat(latLong.substring(0, posVirg))
              const long = parseFloat(latLong.substring(posVirg + 2, latLong.length))
              this.markers = [
                {
                  position: { lat: lat, lng: long },
                },
              ]

              this.markerOptions = {
                position: { lat: lat, lng: long },
                label: "01",
                title: "Empresa 001"
              }

            }

            this.freteCotaData = res.data[4]


            if (this.freteCotaData && this.freteCotaData.id){
              this.dtListPesqFreteCota = [
                {
                  'codigo': this.freteCotaData.codigo,
                  'nome': this.freteCotaData.nome,
                }
              ]
            }


            this.wmsEnderecosData = res.data[5]
            this.empreTokensData = res.data[6]
            this.emprSegtosData = res.data[7]
            this.emprParamsData = res.data[8]
            this.empreCertDigList = res.data[9]

            this.emprOrigensData = res.data[10]
            this.regrasFretesData = res.data[11]
            this.naturezasList = res.data[12]
            this.slaentregaData = res?.data[13]
            this.slaentregacidadesData = res?.data[14]

            /** Dados fiscal Emissão NF-e */
            this.emprfiscalData = Object.assign({}, this.emprfiscalData, res?.data[15] ?? {})
            if (this.emprfiscalData.created_at && String(this.emprfiscalData.created_at).includes('-')) {
              this.emprfiscalData.created_at = this.formatDateTime(this.emprfiscalData.created_at)
            }
            if (this.emprfiscalData.updated_at && String(this.emprfiscalData.updated_at).includes('-')) {
              this.emprfiscalData.updated_at = this.formatDateTime(this.emprfiscalData.updated_at)
            }

            if(this.empresaData?.naturezapadrao){
              this.checkboxNatureza = true
            }

            if(this.emprParamsData){
              const params = this.emprParamsData
              params.forEach((item) => {
                if(item.valor === 'INSERT_TOMADOR'){
                  this.paramTomador = item.valor
                }
              })
            }

            this.idData = this.empresaData.id
            this.title = `Editar Empresa (${this.empresaData.id}) ${this.empresaData.nome}`

            if (this.empresaData.avisentr) {
              const avisos = this.empresaData.avisentr.split(",")
              const avisosSelecionados = []
              avisos.forEach((item) => {
                avisosSelecionados.push(item)
              })
              this.empresaDatas.avisentr = avisosSelecionados
            }
            this.updating = false
          }
        })
      }else{
        this.title = `Criando Nova Empresa`
        this.updating = false
      }
    },

    pesqCidadeSLA(query) {
    if (query.length > 2){
      api.get(`${getBaseUrl()}api/cidpesq`, {
        params: { q: query }
      }).then((res) => {
        this.cidadesDataSLA = res.data;
      });
    }
  },

    confirmarSlaEntrega() {
      console.log('confirmarSlaEntrega')
      console.log(this.slaentrega)

      if (!("diassla" in this.slaentrega) || this.slaentrega.diassla === "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Dias de entrega é obrigatório!",
          showConfirmButton: false,
          timer: 4000,
        })
        return
      }

      if (!("diasuteis" in this.slaentrega)) {
        this.slaentrega.diasuteis = 'CORRIDOS'
      }

      this.slaentrega.empresa_id = this.empresaData.id
      api.post(`${getBaseUrl()}api/slaentrega`, {
        slaentrega: this.slaentrega,
        cidadesla: this.slaentregacidades
      }).then((res) => {
        console.log('then axios slaentrega')
        console.log(res.data)

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            text: "dados salvos com sucesso!",
            icon: "success",
            showConfirmButton: false,
            timer: 3500
          }).then(()=> {
            this.atualizaPagina()
          })
        }
        this.showModalSlaEntrega = false
      })      
      console.log(this.slaentrega)
    },

    limparDados() {
      console.log('limparDados')
      this.slaentrega = {
        diassla: 0,
        diasuteis: "CORRIDOS"
      }

      this.slaentregacidade = {}
    },

    salvarRegraCobranca() {
      console.log('salvarRegraCobranca')
      console.log(this.emprparamcobranca)

      /**
       * Validações principais
       */
      if(this.emprparamcobranca.textocobr === null || this.emprparamcobranca.textocobr === "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Texto da cobrança é obrigatório!",
          showConfirmButton: false,
          timer: 4000,
        })

        return
      }

      if(this.emprparamcobranca.dados === null || this.emprparamcobranca.dados === "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Texto da cobrança é obrigatório!",
          showConfirmButton: false,
          timer: 4000,
        })

        return
      }

      if(this.dropzoneFile === null || this.dropzoneFile === "") {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Logo é obrigatória",
          showConfirmButton: false,
          timer: 4000,
        })

        return
      }
      this.submittedAnexo = true;
      if (this.dropzoneFile.name) {
        this.showModalAtuLogo = false;
        this.updating = true;

        let arquivo = document.querySelector(".dropzoneFile").files[0];
        console.log(arquivo);

        let arquivoEmMegas = arquivo.size / 1000;

        if (arquivoEmMegas > 500) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Arquivo não pode ultrapassar 500 Kb!",
            showConfirmButton: false,
            timer: 4000,
          }).then(() => {
            this.submittedAnexo = false;
            this.dropzoneFile = "";
            this.carregarDados();
          });
        } else {
          let formData = new FormData();
          formData.append("iddata", this.idData);
          formData.append("filename", arquivo.name);
          formData.append("file", arquivo);
          formData.append("emprparamcobranca", JSON.stringify(this.emprparamcobranca))

          console.log('dados formData:')
          console.log(JSON.stringify(formData))

          api.post(`${getBaseUrl()}api/empreparamcobranca`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }).then((res) => {
              console.log("then axios empreparamcobranca");
              console.log(res.data);

              if (res.data.success) {
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Regra de Financeiro Salva com sucesso!",
                  showConfirmButton: false,
                  timer: 2000,
                }).then(() => {
                    this.emprparamcobranca = res.data.emprparamcobranca;
                    this.carregarDados();
                  })
              } else {
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: "Processamento falhou!",
                  text: res.data.error,
                  showConfirmButton: false,
                  timer: 5000,
                })
              }
            })
            .catch((err) => {
              console.log("erro axios");
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors;
              console.log(erros);
              console.log(typeof erros);
              let listaErros = [];
              Object.keys(erros).forEach((key) => {
                console.log(key, erros[key]);
                listaErros.push({
                  titulo: key,
                  mensagem: erros[key],
                });
              });
              this.showModalAddCampanha = false;
              this.errosValid = listaErros;
              this.updating = false;
            });
        }
      }
    },

    formatDescricaoParam(parametro) {

      if (parametro.descricao) {
        return parametro.descricao
      }

      /**
       * Formatando descricao padrão
       */
      switch (parametro.valor) {
        case "COD_COTA_CORR":
            return "Código de serviço default para cotação de Fretes nos Correios"
        case "COTAAUTO":
            return "Cotação automática de frete na entrada de notas"
        case "CTE_CONC_AUTO":
            return "Conciliação automática na inserção de CTE"
        case "CTE_CONC_PRZ_MOV":
          return "Na Conciliação de CTE atualizar prazo da mov"
        case "CONF_PARC_FIN":
            return "Conferencia parcial como status finalizador"
        case "DT_FECHA_ESTQ":
            return "Data de fechamento do estoque"
        case "INSERT_TOMADOR":
            return "Insert empresa tomadora do frete"
        case "NOVO_FLUXO_SALDO":
            return "Novo fluxo de saldo"
        case "LINK_RASTREIO":
            return "Link para rastreio de entregas"
        case "GERA_AUTO_OS_API_ORCAMENTO":
            return "Criação de OS de daída ao criar um orçamento via API"
        case "ADICIONA_VOLUME_ROMANEIO":
            return "Adiciona automaticamente o volume no romaneio baseado na nota fiscal"
        case "ARQ_PROJ_VISIO":
            return "Id do arquivo (gDrive) de gerenciamento de projetos para download"
        case "FORCE_TRANSF_WMSROMA":
            return "Transfere OS entre romaneios (mesmo finalizado)"
        case "GERA_ROMA_ORCTO":
            return "Gerar romaneio com informações de orçamento"
        case "IMPR_ETIQ_ORCTO":
            return "Impressão tipo mini-danfe de orçamento"
        case "ADD_CAMPANHA":
            return "Adicionar Logos de campanhas aos pedidos/Orçamentos"
        case "FORCE_ADD_ITEMS":
            return "Inserir itens mesmo após a confirmação de um Pedido"
        case "NOT_BUSCA_EAN":
            return "Não buscar EAN para POST de Orçamentos API"
        case "NAO_CADASTRAR_PROD_AUTO":
            return "Não adicionar produtos automaticamente ao carregar uma nota fiscal"
        case "LOTE_WMSOS":
            return "Informar lote no estágio de conferência"
        case "GERAR_FINANC_FRETE":
            return "Geração de financeiro para frete"
        case "GERA_OS_PDF_RELATORIO":
            return "Habilitar impressão de PDF ao conferir OS saida"
        case "NOVO_REGER_SALDO":
            return "Regerar saldo(novo)"
        case "DELETE_PRODUTOSALDO":
            return "Deleção de Histórico de produto"
        case "EDIT_DOCCOB":
            return "Editar informações de Doccob"
        case "USA_WPP_CAD_CLIENTE":
          return "Utilizar apenas número do cadastro de cliente para mensagens WhatsApp"
        case "NAO_SOLICITA_COLETA_AUTO":
          return "Não solicitar coleta automaticamente ao finalizar romaneio"
      }
    },

    editarRegraFrete(data){
      console.log('editarOrigem')
      this.regraFreteData = data
      this.showFormRegraFrete = true
    },



    deletarRegraFrete(dataID) {
      console.log('deletarRegraFrete')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Regra de Frete",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/emprrefrete`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.atualizaPagina()
            })
          })
        }
      })
    },

    confRegraFrete() {
      console.log('confRegraFrete')
      console.log(this.regraFreteData)
      let existeRegraApi = false
      if (this.regraFreteData.tipo.includes('API_')) {
        this.regrasFretesData.forEach((value) => {
          if (value.tipo.includes('API_')) {
            existeRegraApi = true
          }
        })
      }
      if (existeRegraApi){
        Swal.fire({
          position: "center",
          icon: 'warning',
          text: 'Apenas uma regra pode ser definida para API de cotação de fretes da empresa.',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000
        })
      } else {
        this.submittedRegraFrete = true
        this.regraFreteData.emprid = this.idData
        if ((this.regraFreteData.tipo) &&
            ((this.regraFreteData.destino && this.regraFreteData.cnpjtransp && (this.regraFreteData.tipo === 'BLOQ_DEST_EST' || this.regraFreteData.tipo === 'FIX_DEST_EST'))
                || this.regraFreteData.valor && (this.regraFreteData.tipo === 'API_MIN_PRC_TOL' || this.regraFreteData.tipo === 'API_MIN_PRZ_TOL')
                || (this.regraFreteData.tipo === 'API_MIN_PRC' || this.regraFreteData.tipo === 'API_MIN_PRZ')
            )
        ) {
          this.showFormRegraFrete = false
          this.updating = true
          api.post(`${getBaseUrl()}api/emprrefrete`, {
            emprReFreteData: this.regraFreteData
          }).then((res) => {
            console.log('then axios')
            console.log(res)
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.updating = false
            })
            this.atualizaPagina()
          }).catch((err) => {
            console.log('erro axios')
            console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false
          })
        }
      }
    },


    editarCertDig(data){
      this.empreCertDigData.nome = data.nome
      this.empreCertDigData.validade = this.formatDate(data.validade)
      this.empreCertDigData.senha = data.senha
      this.empreCertDigData.tipo = data.tipo
      this.empreCertDigData.id = data.id

      this.showModalCertDigital = true
    },

    cancelaCertDig(){
      this.empreCertDigData.id = null
      this.empreCertDigData.tipo = 'A1'
      this.empreCertDigData.senha = null
      this.empreCertDigData.validade = null
      this.empreCertDigData.nome = null

      this.showModalCertDigital = false
    },

    deletarCertDig(certdig_id){
      console.log('deletarCertDig')

      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: "Deseja realmente remover o Certificado Digital?",
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar'
      }).then((res) => {
        if(res.isConfirmed){
          console.log('deleting certificado digital')
          api.delete(`${getBaseUrl()}api/certdig`, {
            params: {
              iddata: this.idData,
              certdig_id: certdig_id
            }
          }).then(res => {
            console.log('then deleting certificado')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: res.data.message,
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.atualizaPagina()
              })
            }else{
              Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: res.data.message,
                showConfirmButton: false,
                timer: 2000
              })
            }
          })
        }
      })
    },

    deletarcidadesla(id) {
      console.log('deletarcidadesla')
      console.log(id)
      api.delete(`${getBaseUrl()}api/slaentregacidade`, {
        params: {
          id: id
        }
      }).then(res => {
        console.log('then deleting cidadesla')
        console.log(res.data)

        if(res.data.success){
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: res.data.message,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            this.atualizaPagina()
          })
        }else{
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.data.message,
            showConfirmButton: false,
            timer: 2000
          })
        }
      })
    },

    novoEmprParam(){
      this.showFormEmprParam = true
      this.emprParamData = {}
    },

    editarEmprParam(dataEmprParam){
      console.log('editarEmprParam')
      console.log(dataEmprParam)
      this.emprParamData = dataEmprParam
      this.emprParamData.dataF = moment(dataEmprParam.data).format("YYYY-MM-DD")
      this.showFormEmprParam = true
    },




    escolheuTransp(){
      console.log('adding')

    },

    pesqTransp(evt) {
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqTransp = res.data
        })
      }
    },

    testarwebhook(){
      console.log('testing webhook')
      console.log(this.empresaData.urlwebhook)

      if(this.empresaData.urlwebhook){
        api.post(`${getBaseUrl()}api/testarwebhook`, {
          urlcallback: this.empresaData.urlwebhook
        })
            .then((res) => {
              console.log('then axios')
              console.log(res.data)

              Swal.fire({
                position: "center",
                icon: 'info',
                text: res.data[0],
                showCancelButton: false,
                showConfirmButton: false,
                timer: 3000
              })
            });
      }else{
        Swal.fire({
          position: "center",
          icon: 'warning',
          text: 'URL de callback não foi definida!',
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000
        })
      }
    },

    ativawebhook(){
      console.log('switching webhook...')

      this.empresaData.ativawebhook = !this.empresaData.ativawebhook

    },

    showInstrucoesBoleto() {
      Swal.fire({
        icon: 'info',
        title: 'Instruções',
        html: `
          O campo <strong>Mensagens de Instruções</strong> é opcional e permite adicionar até 5 mensagens, com no máximo 40 caracteres.
          <br><br>
          A configuração funciona da seguinte forma: caso sejam confirmadas as variáveis de juros, multa e desconto, elas serão automaticamente alocadas nas primeiras mensagens.
          <br><br>
          <strong>Exemplo:</strong><br>
          mensagem1 [$juros]% ao dia; <br>
          mensagem2 [$multa]% após o vencimento; <br>
          mensagem3 [$desconto]% se pago até o vencimento; <br>
          mensagem4; <br>
          mensagem5
        `,
        width: 600
      });
    },

    updateInstrucoesBoleto() {
      if (this.empreTokemData.hub_class !== 'bancaria') return;

      let instrucoesPJ = (this.empreTokemData.instrucoes_boleto_pj || '').split(';');
      while (instrucoesPJ.length < 5) instrucoesPJ.push('');
      
      if (this.empreTokemData.juros_ativo) {
        if (!instrucoesPJ[0].includes('[$juros]')) instrucoesPJ[0] = instrucoesPJ[0].trim() ? instrucoesPJ[0] + ' [$juros]' : '[$juros]';
      }
      if (this.empreTokemData.multapj_ativo) {
        if (!instrucoesPJ[1].includes('[$multa]')) instrucoesPJ[1] = instrucoesPJ[1].trim() ? instrucoesPJ[1] + ' [$multa]' : '[$multa]';
      }
      if (this.empreTokemData.desconto_ativo) {
        if (!instrucoesPJ[2].includes('[$desconto]')) instrucoesPJ[2] = instrucoesPJ[2].trim() ? instrucoesPJ[2] + ' [$desconto]' : '[$desconto]';
      }
      this.empreTokemData.instrucoes_boleto_pj = instrucoesPJ.join(';');

      let instrucoesPF = (this.empreTokemData.instrucoes_boleto_pf || '').split(';');
      while (instrucoesPF.length < 5) instrucoesPF.push('');

      if (this.empreTokemData.juros_ativo) {
        if (!instrucoesPF[0].includes('[$juros]')) instrucoesPF[0] = instrucoesPF[0].trim() ? instrucoesPF[0] + ' [$juros]' : '[$juros]';
      }
      if (this.empreTokemData.multapf_ativo) {
        if (!instrucoesPF[1].includes('[$multa]')) instrucoesPF[1] = instrucoesPF[1].trim() ? instrucoesPF[1] + ' [$multa]' : '[$multa]';
      }
      if (this.empreTokemData.desconto_ativo) {
        if (!instrucoesPF[2].includes('[$desconto]')) instrucoesPF[2] = instrucoesPF[2].trim() ? instrucoesPF[2] + ' [$desconto]' : '[$desconto]';
      }
      this.empreTokemData.instrucoes_boleto_pf = instrucoesPF.join(';');
    },

    validarToken(){
      this.loadingEmprTokemData = true
      console.log('validarToken')
      api.get(`${getBaseUrl()}api/valtokcor`, {
        params: { iddata: this.empreTokemData.id }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.loadingEmprTokemData = false
        this.empreTokemData = res.data[1]

        Swal.fire({
          position: "top-end",
          icon: 'info',
          text: res.data[0],
          showCancelButton: false,
          showConfirmButton: false,
          timer: 5000
        })
      });
    },

    ativaHub(hub){
      console.log('ativaHub')
      console.log(hub)

      api.post(`${getBaseUrl()}api/ativahub`, {
        iddata: this.idData,
        hub: hub
      }).then((res) => {
        console.log(res)

        if(res.data === false){
          Swal.fire({
            position: "top-end",
            icon: 'info',
            text: 'Esse hub não necessita de ativação!',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 3000
          })
        }else{
          if(res.data.link){
            this.linkredirect = res.data.link
            window.open(this.linkredirect, '_blank')
          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: res.data.message,
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            }).then(() => {
              this.atualizaPagina()
            })
          }
        }
      })
    },

    editarToken(id){
      console.log('editarToken ' + id)
      api.get(`${getBaseUrl()}api/emprtoken`, {
        params: { iddata: id }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empreTokemData = res.data[0]

        if (this.empreTokemData.juros === undefined && this.empreTokemData.juros_valor !== undefined) this.empreTokemData.juros = this.empreTokemData.juros_valor;
        if (this.empreTokemData.multa === undefined && this.empreTokemData.multa_valor !== undefined) this.empreTokemData.multa = this.empreTokemData.multa_valor;
        if (this.empreTokemData.desconto === undefined && this.empreTokemData.desconto_valor !== undefined) this.empreTokemData.desconto = this.empreTokemData.desconto_valor;
        
        if (!this.empreTokemData.instrucoes_boleto && this.empreTokemData.msg_instrucao) {
             this.empreTokemData.instrucoes_boleto = this.empreTokemData.msg_instrucao;
        }

        const selectedHub = this.empreTokenHubs.find(h => h.value === this.empreTokemData.hub);
        if (selectedHub) {
          this.empreTokemData.hub_class = selectedHub.classe;

          if (this.empreTokemData.hub_class === 'bancaria') {
            if (this.empreTokemData.juros_ativo === undefined) this.empreTokemData.juros_ativo = false;
            
            if (this.empreTokemData.multapj_ativo === undefined) this.empreTokemData.multapj_ativo = this.empreTokemData.multa_ativo || false;
            if (this.empreTokemData.multapf_ativo === undefined) this.empreTokemData.multapf_ativo = this.empreTokemData.multa_ativo || false;
            
            if (this.empreTokemData.desconto_ativo === undefined) this.empreTokemData.desconto_ativo = false;

            if (this.empreTokemData.multapj === undefined || this.empreTokemData.multapj === '0,00') {
              this.empreTokemData.multapj = this.empreTokemData.multa || '0,00';
            }
            if (this.empreTokemData.multapf === undefined || this.empreTokemData.multapf === '0,00') {
              this.empreTokemData.multapf = this.empreTokemData.multa || '0,00';
            }
            
            const cleanPJ = (this.empreTokemData.instrucoes_boleto_pj || '').replace(/;/g, '').trim();
            if (!this.empreTokemData.instrucoes_boleto_pj || cleanPJ === '') {
              this.empreTokemData.instrucoes_boleto_pj = this.empreTokemData.msg_instrucaopj || this.empreTokemData.instrucoes_boleto || this.empreTokemData.msg_instrucao || '';
            }

            const cleanPF = (this.empreTokemData.instrucoes_boleto_pf || '').replace(/;/g, '').trim();
            if (!this.empreTokemData.instrucoes_boleto_pf || cleanPF === '') {
              this.empreTokemData.instrucoes_boleto_pf = this.empreTokemData.msg_instrucaopf || this.empreTokemData.instrucoes_boleto || this.empreTokemData.msg_instrucao || '';
            }
          }
        }

        if (this.empreTokemData.is_equivalence) {
          this.showFormEquivalence = true
          this.equivalenceTokens = res.data[1]

          if (this.equivalenceTokens && this.equivalenceTokens.length > 0) {
              this.equivalenceTokens.forEach(token => {
                  if (token.juros === undefined && token.juros_valor !== undefined) token.juros = token.juros_valor;
                  
                  if (token.multapj_ativo === undefined) token.multapj_ativo = token.multa_ativo || false;
                  if (token.multapf_ativo === undefined) token.multapf_ativo = token.multa_ativo || false;

                  if (token.multapj === undefined || token.multapj === '0,00') {
                      token.multapj = token.multa || '0,00';
                  }
                  if (token.multapf === undefined || token.multapf === '0,00') {
                      token.multapf = token.multa || '0,00';
                  }

                  const cleanEquivPJ = (token.instrucoes_boleto_pj || '').replace(/;/g, '').trim();
                  if (!token.instrucoes_boleto_pj || cleanEquivPJ === '') {
                    token.instrucoes_boleto_pj = token.msg_instrucaopj || token.instrucoes_boleto || token.msg_instrucao || '';
                  }
                  
                  const cleanEquivPF = (token.instrucoes_boleto_pf || '').replace(/;/g, '').trim();
                  if (!token.instrucoes_boleto_pf || cleanEquivPF === '') {
                    token.instrucoes_boleto_pf = token.msg_instrucaopf || token.instrucoes_boleto || token.msg_instrucao || '';
                  }

                  if (token.multa === undefined && token.multa_valor !== undefined) token.multa = token.multa_valor;
                  if (token.desconto === undefined && token.desconto_valor !== undefined) token.desconto = token.desconto_valor;
                  if (!token.instrucoes_boleto && token.msg_instrucao) token.instrucoes_boleto = token.msg_instrucao;
              });
          }
        } else {
          this.showFormToken = true
        }
        
      })
    },


    editarOrigem(data){
      console.log('editarOrigem')
      this.emprOrigemData = data
      this.showFormOrigem = true
    },


    deletarEmprToken(dataID) {
      console.log('deletarEmprToken')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Token",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/emprtoken`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.empreTokensData = res.data[0]
              this.atualizaPagina()
            })
          })
        }
      })
    },


    deletarEmprParam(dataID) {
      console.log('deletarEmprParam')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Parâmetro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
      console.log(`idData: ${dataID}`)

        this.updating = true
        if (result.isConfirmed) {
          api.delete(`${getBaseUrl()}api/emprparam`,{
            params: {
            'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.emprParamsData = res.data[0]
              this.updating = false
            })
          }).then(() => {
            //this.atualizaPagina()
          })
        }
      })
    },


    deletarEmprSegto(dataID) {
      console.log('deletarEmprSegto')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Seguimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/emprsegto`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.emprSegtosData = res.data[0]
              this.atualizaPagina()
            })
          })
        }
      })
    },


    deletarEmprOrigem(dataID) {
      console.log('deletarEmprOrigem')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Origem Cotação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/emprorigem`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.atualizaPagina()
            })
          })
        }
      })
    },

    modalSLAEntrega(data) {
      console.log('modalSLAEntrega')
      console.log(data)
      if (typeof data !== 'undefined') {
        this.slaentrega = data
        this.slaentregacidades = this.slaentregacidadesData.filter(item => item.slaentrega_id === data.id)
      } else {
        this.slaentregacidades = []
        this.slaentrega = {
          diassla: 0,
          diasuteis: "CORRIDOS"
        }
        
      }

      
      this.showModalSlaEntrega = true
    },

    async modalSLAEntregaCidade() {
      console.log('modalSLACidade')
      // const res = await api.get(`${getBaseUrl()}api/getcidade`)

      // console.log(res.data.length)
      // this.cidadesData = res?.data[0]
      
      this.showModalSlaEntrega = false
      this.showModalSlaEntregaCidade = true
      this.cidadeSelecionadaSLA = null
    },

    deletarSLAEntrega(id) {
      console.log('deletarSLAEntrega')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de SLA de Entrega",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
      console.log(`idData: ${id}`)

        this.updating = true
        if (result.isConfirmed) {
          api.delete(`${getBaseUrl()}api/slaentrega`,{
            params: {
            'id': id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.atualizaPagina()
            })
          })
        }
      })
    },

    AdicionarCidade() {
      console.log('AdicionarCidade')
      console.log(this.cidadeSelecionadaSLA)
      const item = this.cidadesDataSLA.find(item => item.id === parseInt(this.cidadeSelecionadaSLA))
      this.cidadeSelecionadaSLAData = {
        id: null,
        cidade_id: item.id,
        cidade: item.descricao,
        estado: item.estado,
        ibgecodigo: item.codigo,
        slaentrega_id: this.slaentrega.id ?? null
      }
      this.slaentregacidades.push(this.cidadeSelecionadaSLAData)
      this.showModalSlaEntregaCidade = false
      this.showModalSlaEntrega = true
      console.log('cidadesAdionadas')
      console.log(this.slaentregacidadesData)
    },

    confirmarSlaEntregaCidade() {
      console.log('confirmarSlaEntregaCidade')

      const item = this.cidadesDataSLA.find(item => item.id === parseInt(this.cidadeSelecionadaSLA))
      this.cidadeSelecionadaSLAData = {
        cidade_id: item.id,
        cidade: item.descricao,
        estado: item.estado,
        ibgecodigo: item.codigo,
        slaentrega_id: this.slaentrega.id
      }
      
      api.post(`${getBaseUrl()}api/slaentregacidade`, {
        slaentregacidade: this.cidadeSelecionadaSLAData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showModalSlaEntregaCidade = false

        // this.usuarioData = res.data[0]
        // this.updating = false
        //
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.atualizaPagina()
        })
      }).catch((err) => {
        console.log('erro axios')
        console.log(err)

        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro ao salvar informações!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    confToken(isEquivalence) {
      console.log('confToken')

      this.empreTokemData.empresa_id = this.idData
      this.empreTokemData.is_equivalence = isEquivalence

      if (this.empreTokemData.hub) {

        let payload = { ...this.empreTokemData };

        if (payload.hub_class === 'bancaria') {
             const juros = payload.juros || '0,00';
             const multapj = payload.multapj || '0,00';
             const multapf = payload.multapf || '0,00';
             const desconto = payload.desconto || '0,00';

             let msgPJ = payload.instrucoes_boleto_pj || '';
             msgPJ = msgPJ.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapj)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payload.msg_instrucaopj = msgPJ;
             let msgPF = payload.instrucoes_boleto_pf || '';
             msgPF = msgPF.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapf)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payload.msg_instrucaopf = msgPF;
        }

        if (payload.transp_cnpj) {
            payload.transp_cnpj = payload.transp_cnpj.replace(/\D/g, '');
        }

        api.post(`${getBaseUrl()}api/emprtoken`, {
          empreTokemData: payload
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormToken = false

          // this.usuarioData = res.data[0]
          // this.updating = false
          //
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {




            this.empreTokensData =res.data[0]
            this.atualizaPagina()
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    saveEquivalenceToken () {
      console.log('saveEquivalenceToken ' + this.equivalenceEditing.id)
      
      let payloadToken = { ...this.empreTokemData };
      
      if (payloadToken.hub_class === 'bancaria') {
             const juros = payloadToken.juros || '0,00';
             const multapj = payloadToken.multapj || '0,00';
             const multapf = payloadToken.multapf || '0,00';
             const desconto = payloadToken.desconto || '0,00';

             let msgPJ = payloadToken.instrucoes_boleto_pj || '';
             msgPJ = msgPJ.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapj)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payloadToken.msg_instrucaopj = msgPJ;

             let msgPF = payloadToken.instrucoes_boleto_pf || '';
             msgPF = msgPF.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapf)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payloadToken.msg_instrucaopf = msgPF;
      }

      if (payloadToken.transp_cnpj) {
        payloadToken.transp_cnpj = payloadToken.transp_cnpj.replace(/\D/g, '');
      }

      let payloadEquivalence = { ...this.equivalenceEditing };

      if (payloadEquivalence.hub_class === 'bancaria') {
             const juros = payloadEquivalence.juros || '0,00';
             const multapj = payloadEquivalence.multapj || '0,00';
             const multapf = payloadEquivalence.multapf || '0,00';
             const desconto = payloadEquivalence.desconto || '0,00';

             let msgPJ = payloadEquivalence.instrucoes_boleto_pj || '';
             msgPJ = msgPJ.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapj)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payloadEquivalence.msg_instrucaopj = msgPJ;

             let msgPF = payloadEquivalence.instrucoes_boleto_pf || '';
             msgPF = msgPF.split(';').map(m => {
                 return m.replace('[$juros]', juros)
                         .replace('[$multa]', multapf)
                         .replace('[$desconto]', desconto);
             }).join('; ');
             payloadEquivalence.msg_instrucaopf = msgPF;
      }

      if (payloadEquivalence.transp_cnpj) {
        payloadEquivalence.transp_cnpj = payloadEquivalence.transp_cnpj.replace(/\D/g, '');
      }

      api.post(`${getBaseUrl()}api/equivalence`, {
        empretoken: payloadToken,
        equivalence: payloadEquivalence
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.atualizaPagina && this.atualizaPagina();
        });
      }).catch((err) => {
        console.log(err.response.data.error)
        let errorMsg = "Ocorreu um erro ao salvar as informações."
        if (err.response.data.error) errorMsg = err.response.data.error
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Erro",
          text: errorMsg,
          showConfirmButton: true
        });
        console.log('erro axios')
        console.log(err)
      });
    },

    delEquivalenceToken (id) {
      console.log('saveEquivalenceToken ' + id)
      Swal.fire({
        title: 'Tem certeza?',
        text: "Deseja realmente deletar o token? Esta ação não poderá ser desfeita.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, deletar!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          api.delete(`${getBaseUrl()}api/equivalence`, {
              params: {
                'iddata': id
              }
            }
          ).then((res) => {
            console.log('then axios')
            console.log(res.data)
            Swal.fire(
              'Deletado!',
              'O item foi deletado com sucesso!',
              'success'
            );
            this.atualizaPagina && this.atualizaPagina();
          }).catch((err) => {
            let errorMsg = "Ocorreu um erro ao salvar as informações."
            if (err.response.data.error) errorMsg = err.response.data.error
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro",
              text: errorMsg,
              showConfirmButton: true
            });
            console.log('erro ao deletar equivalenceToken:', err);
          });
        }
      });
    },

    triggerConfEmprParam(){
      this.updating = true

        api.post(`${getBaseUrl()}api/emprparam`, {
          emprParamData: this.emprParamData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          // this.usuarioData = res.data[0]
          // this.updating = false
          //
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.emprParamsData =res.data[0]
            this.updating = false
          })

          this.atualizaPagina()
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
    },

    confEmprParam() {
      console.log('confEmprParam')
      console.log(this.emprParamData.dataF)
      this.emprParamData.empresa_id = this.idData
      if (this.emprParamData.valor) {
        this.showFormEmprParam = false

        this.emprParamData.data = moment(this.emprParamData.dataF).format("YYYY-MM-DD")

        if(this.emprParamData.valor === "NOVO_REGER_SALDO"){
          Swal.fire({
            position: "center",
            icon: "warning",
            title: "Atenção!",
            text: "Saldos regerados não possuem resgate de informações anteriores! Alguns registros podem ser deletados nesse processo!",
            showConfirmButton: true,
          }).then(() => {
            this.triggerConfEmprParam()
          })
        } else {
          this.triggerConfEmprParam()
        }
      }
    },

    confEmprOrigem() {
      console.log('confEmprOrigem')
      console.log(this.emprOrigemData)
      this.submittedEmprOrigem = true
      this.emprOrigemData.emprid = this.idData
      if (this.emprOrigemData.cep) {
        this.showFormOrigem = false
        this.updating = true
        api.post(`${getBaseUrl()}api/emprorigem`, {
          emprOrigemData: this.emprOrigemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.updating = false
          })
          this.atualizaPagina()
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },


    confSegtoFrete() {
      console.log('confSegtoFrete')
      console.log(this.emprSegtoData)
      this.submittedEmprSegto = true
      this.emprSegtoData.empresa_id = this.idData
      if (this.emprSegtoData.codigo) {

        api.post(`${getBaseUrl()}api/emprsegto`, {
            emprSegtoData: this.emprSegtoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.showFormSegtoFrete = false

          // this.usuarioData = res.data[0]
          // this.updating = false
          //
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {

            this.emprSegtosData =res.data[0]
            this.atualizaPagina()
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    triggerHubSelection(action) {
      this.pendingHubAction = action;
      this.selectedHubClass = null;
      this.showHubSelectionModal = true;
    },

    confirmHubSelection() {
      if (!this.selectedHubClass) return;

      this.showHubSelectionModal = false;
      const action = this.pendingHubAction;
      this.pendingHubAction = null;

      if (action === 'token') {
        this.showFormToken = true;
        this.empreTokemData = {
          hub_class: this.selectedHubClass,
          juros_ativo: false,
          multa_ativo: false,
          desconto_ativo: false
        };
      } else if (action === 'equivalence') {
        this.showFormEquivalence = true;
        this.empreTokemData = {
          hub_class: this.selectedHubClass
        };
        this.equivalenceEditing = {
          hub_class: this.selectedHubClass
        };
        this.equivalenceTokens = [];
      }
    },



    atualizaPagina(){
      window.location.reload();
    },


    deletarWmsEndereco(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/emprewmsender`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.wmsEnderecosData = res.data[0]
          })
        }
      })
    },


    confirmarWmsEndereco(){
      console.log('confirmarWmsEndereco')
      this.loadingWmsEndereco = true
      console.log(this.wmsEnderecoSel)
      if (this.wmsEnderecoSel){
        this.showModalWmsEndereco = false
        api.post(`${getBaseUrl()}api/assocender`, {
          emprcod: this.empresaData.codigo,
          enderdesc: this.wmsEnderecoSel
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.wmsEnderecosData = res.data[0]
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.wmsEnderecoSel = null
        })
      }
    },


    pesqWmsEndereco(evt) {
      console.log('pesqWmsEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingWmsEndereco = true
        //this.orctoData.condpgto = ''
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "empresa", origem_id: this.empresaData.id}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqWmsEndereco = res.data
        })
      }
    },

    escolheuWmsEndereco() {
      console.log('escolheuWmsEndereco')
      this.loadingWmsEndereco = true
      console.log(this.wmsEnderecoSel)
      api.post(`${getBaseUrl()}api/assocender`, {
        emprcod: this.empresaData.codigo,
        enderdesc: this.wmsEnderecoSel
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.wmsEnderecosData = res.data[0]
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.showModalWmsEndereco = false
        this.dtListPesqWmsEndereco = null
        this.wmsEnderecoSel = null
        this.loadingWmsEndereco = false
      })
    },


    novoEndereco(){
      console.log('novoEndereco')
      this.showModalWmsEndereco = true


    },


    pesqFreteCota(evt){
      console.log('pesqFreteCota')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.loadingTransp = true
        this.empresaData.transp = ''
        api.get(`${getBaseUrl()}api/pesqfretecota`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteCota = res.data
        })
      }
    },

    escolheuFreteCota(){
      console.log('escolheuFreteCota')
      //this.loadingTransp = true
      console.log(this.empresaData.segto)
      api.get(`${getBaseUrl()}api/fretecotacod`, {
        params: { coddata: this.empresaData.segto }
      }).then((res) => {
        console.log('then axios_escolheu_fretecota')
        console.log(res.data)
        this.freteCotaData = res.data[0]
        //this.loadingTransp = false
      })
    },

    confCertDig(){
      console.log('confCertDig')
      this.submittedAnexo = true
      if (this.dropzoneFile.name){
        this.showModalCertDigital = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("tipoUpload", this.tipoUpload)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)
        formData.append("tipo", this.empreCertDigData.tipo)
        formData.append("senha", this.empreCertDigData.senha)
        formData.append("validade", this.empreCertDigData.validade)
        formData.append("id", this.empreCertDigData.id)
        formData.append("manifest", this.empreCertDigData.manifest)

        api.post(`${getBaseUrl()}api/certdig`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios certdig')
          console.log(res.data)

          if(res.data.success){
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.showModalCertDigital = false
              this.atualizaPagina()
            })
          }else{
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.atualizaPagina()
            })
          }
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },


    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.dropzoneFile.name){
        this.showModalAtuLogo = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("tipo", this.tipoUpload)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/emprlogo`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]

            this.mediasData.forEach((value) => {

              console.log('value_medias')
              console.log(value.descricao)

              if (value.descricao === "empr01_w.png"){
                api.get(`${getBaseUrl()}api/getfile`, {
                  responseType: 'blob',
                  params: { pathData: value.path }
                }).then((res) => {
                  // console.log('baixararq')
                  // console.log(res)
                  this.blobUrlWhite = URL.createObjectURL(res.data)
                })
              }

              else if (value.descricao === "empr01_b.png"){
                api.get(`${getBaseUrl()}api/getfile`, {
                  responseType: 'blob',
                  params: { pathData: value.path }
                }).then((res) => {
                  // console.log('baixararq')
                  // console.log(res)
                  this.blobUrlBlack = URL.createObjectURL(res.data)
                })
              }

              else if (value.descricao === "empr01_danfe.jpg"){
                api.get(`${getBaseUrl()}api/getfile`, {
                  responseType: 'blob',
                  params: { pathData: value.path }
                }).then((res) => {
                  // console.log('baixararq_danfe')
                  // console.log(res)
                  this.blobUrlDanfe = URL.createObjectURL(res.data)
                })
              }

            })

          this.updating = false


          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })
      }
    },

    novoAnexo(){
      console.log('novoAnexo')
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },

    consultarEndereco(){
      console.log('consultarEndereco')
      this.showModalEndereco = true


    },


    pesqCidade(evt){
      console.log('pesqCidade')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade = res.data
        });
      }
    },

    escolheuCidade(){
      console.log('escolheuCidade')
      // console.log(this.empresaData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.empresaData.codmun }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData.cidade = res.data.descricao
        this.empresaData.estado = res.data.estado

      })
    },

    consultarCEP(){
      console.log('consultarCEP')
      const cepTratado = this.empresaData.cep.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length !== 8){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CEP deve possuir no mínimo 8 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cepTratado)
        console.log(cepTratado.length)
        this.showModalConsCEP = true
        this.loadingDadosCep = true

        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.consCnpjEndereco = res.data.logradouro
          this.consCnpjCompl = res.data.complemento
          this.consCnpjBairro = res.data.bairro
          this.consCnpjCidade = res.data.localidade
          this.consCnpjEstado = res.data.uf

          this.consCnpjImpEndereco = this.empresaData.rua !== this.consCnpjEndereco
          this.consCnpjImpCompl = this.empresaData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.empresaData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.empresaData.cidade !== this.consCnpjCidade
          this.consCnpjImpEstado = this.empresaData.estado !== this.consCnpjEstado


          this.loadingDadosCep = false
        });
      }


    },


    consultarCNPJ(){
      console.log('consultarCNPJ')
      const cnpjTratado = this.empresaData.cnpj.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratado.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratado)
        console.log(cnpjTratado.length)
        this.showModalConsCNPJ = true
        this.loadingDadosCnpj = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: { cnpj: cnpjTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.consCnpjSituacao = res.data[0].situacao
          this.consCnpjDAbe = res.data[0].abertura
          this.consCnpjSocio1 = res.data[0].qsa.nome
          this.consCnpjSocio2 = res.data[0].qsa.nome

          this.consCnpjFantasia = res.data[0].fantasia
          this.consCnpjNome = res.data[0].nome
          this.consCnpjCnpj = res.data[0].cnpj
          this.consCnpjCep = res.data[0].cep
          this.consCnpjEndereco = res.data[0].logradouro
          this.consCnpjNumero = res.data[0].numero
          this.consCnpjCompl = res.data[0].compl
          this.consCnpjBairro = res.data[0].bairro
          this.consCnpjCidade = res.data[0].municipio
          this.consCnpjEstado = res.data[0].uf
          this.consCnpjEmail = res.data[0].email
          this.consCnpjTel = res.data[0].telefone

          console.log(this.empresaData.fantasia)
          console.log(this.consCnpjFantasia)

          this.consCnpjImpFantasia = this.empresaData.fantasia !== this.consCnpjFantasia
          this.consCnpjImpNome = this.empresaData.nome !== this.consCnpjNome
          this.consCnpjImpCnpj = this.empresaData.cnpj !== this.consCnpjCnpj
          this.consCnpjImpCep = this.empresaData.cep !== this.consCnpjCep
          this.consCnpjImpEndereco = this.empresaData.rua !== this.consCnpjEndereco
          this.consCnpjImpNumero = this.empresaData.numero !== this.consCnpjNumero
          this.consCnpjImpCompl = this.empresaData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.empresaData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.empresaData.cidade !== this.consCnpjCidade
          this.consCnpjImpEstado = this.empresaData.estado !== this.consCnpjEstado
          this.consCnpjImpEmail = this.empresaData.email !== this.consCnpjEmail
          this.consCnpjImpTel = this.empresaData.tel1 !== this.consCnpjTel



          this.loadingDadosCnpj = false
        });
      }
    },

    consultarCNPJTomador(){
      console.log('consultarCNPJ')
      const cnpjTratadoTomador = this.empresaData.cnpj_tomador.replaceAll('.','').replaceAll('/','').replaceAll('-','')
      if (cnpjTratadoTomador.length !== 14){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CNPJ deve possuir no mínimo 14 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cnpjTratadoTomador)
        console.log(cnpjTratadoTomador.length)
        // this.showModalConsCNPJ = true
        this.loadingDadosCnpjTomador = true

        api.get(`${getBaseUrl()}api/conscnpj`, {
          params: { cnpj: cnpjTratadoTomador }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.empresaData.nome_tomador = res.data[0].nome
          this.empresaData.cnpj_tomador = res.data[0].cnpj

          this.loadingDadosCnpjTomador = false
        });
      }
    },


    confirmarImpCep(){
      console.log('confirmarImpCep: ')
      if (this.consCnpjImpEndereco){
        this.empresaData.rua = this.consCnpjEndereco
      }
      if (this.consCnpjImpBairro){
        this.empresaData.bairro = this.consCnpjBairro
      }
      if (this.consCnpjImpCidade){
        this.empresaData.cidade = this.consCnpjCidade
      }
      if (this.consCnpjImpUf){
        this.empresaData.estado = this.consCnpjEstado
      }
      if (this.consCnpjImpCompl){
        this.empresaData.compl = this.consCnpjCompl
      }

      this.showModalConsCEP = false

    },


    confirmarImpCnpj(){
      console.log('confirmarImpCnpj: ' + this.idData)
      if (this.consCnpjImpNome){
        this.empresaData.nome = this.consCnpjNome
      }
      if (this.consCnpjImpFantasia){
        this.empresaData.fantasia = this.consCnpjFantasia
      }
      if (this.consCnpjImpEndereco){
        this.empresaData.rua = this.consCnpjEndereco
      }
      if (this.consCnpjImpNumero){
        this.empresaData.numero = this.consCnpjNumero
      }
      if (this.consCnpjImpBairro){
        this.empresaData.bairro = this.consCnpjBairro
      }
      if (this.consCnpjImpCidade){
        this.empresaData.cidade = this.consCnpjCidade
      }
      if (this.consCnpjImpUf){
        this.empresaData.estado = this.consCnpjEstado
      }
      if (this.consCnpjImpCep){
        this.empresaData.cep = this.consCnpjCep
      }
      if (this.consCnpjImpEmail){
        this.empresaData.email = this.consCnpjEmail
      }
      if (this.consCnpjImpTel){
        this.empresaData.tel1 = this.consCnpjTel.substring(0, 15)
      }
      if (this.consCnpjImpCnpj){
        this.empresaData.cnpj = this.consCnpjCnpj
      }
      if (this.consCnpjImpCompl){
        this.empresaData.compl = this.consCnpjCompl
      }
      this.showModalConsCNPJ = false

    },


    onChangeCheckbox() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$refs.checkboxnatureza?.blur()
        })
      })
    },

    mudouCheckboxNatureza(){
      // console.log('mudouCheckboxNatureza')
      if (!this.checkboxNatureza) {
        this.empresaData.naturezapadrao = null
        this.salvar()
      } else {
        this.empresaData.naturezapadrao = this.naturezasList[0]?.id ?? null
      }
    },

    salvar(){
      this.submitted = true;
      this.v$.$touch()
      console.log('salvarEmpresa')
      if (this.empresaData.codigo && this.empresaData.nome !== ''
          && this.empresaData.fantasia && this.empresaData.fantasia !== ''
          && this.empresaData.razao && this.empresaData.razao !== ''
          && this.empresaData.cnpj && this.empresaData.cnpj !== '') {
        console.log('salvarEmpresa_00')
        this.updating = true

        const dadosParaBackend = {
          ...this.empresaData,
          ...this.empresaDatas,
        };

        // Sanitização de campos com máscara
        const camposLimpar = ['cnpj', 'cep', 'tel', 'tel2', 'cnpj_tomador'];
        camposLimpar.forEach(campo => {
          if (dadosParaBackend[campo]) {
            dadosParaBackend[campo] = String(dadosParaBackend[campo]).replace(/\D/g, '');
          }
        });

        if (Array.isArray(dadosParaBackend.avisentr)) {
          dadosParaBackend.avisentr = dadosParaBackend.avisentr.join(',');
        }

        this.errosValid = []
        api.post(`${getBaseUrl()}api/empresa`, {
          empresaData: dadosParaBackend
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.empresaData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          localStorage.removeItem('emprconf')
          localStorage.removeItem('empratu')

          if (this.idData === 0){
            console.log('redirecionar')
            this.$router.replace({ path: `/empresa/editar/${this.empresaData.id}` })
            this.idData = this.empresaData.id
            // this.carregarDados()
          }

        }).catch((err) => {
          console.log('erro axios', err.response)
          this.updating = false

          const camposNomes = {
            // Identificação
            codigo: 'Código',
            nome: 'Nome',
            razao: 'Razão Social',
            fantasia: 'Nome Fantasia',
            cnpj: 'CNPJ',
            regtrib: 'Regime Tributário',
            inscricao: 'Inscrição Estadual',
            cnae: 'CNAE',
            status: 'Status',
            stsblauto: 'Status de Bloqueio Automático',
            ucodprod: 'Código Único de Produto',
            // Contato
            email: 'E-mail',
            tel1: 'Telefone 1',
            tel2: 'Telefone 2',
            // Endereço
            rua: 'Rua / Logradouro',
            numero: 'Número',
            compl: 'Complemento',
            bairro: 'Bairro',
            codmun: 'Código do Município',
            cidade: 'Cidade',
            estado: 'Estado',
            cep: 'CEP',
            latlong: 'Coordenadas (Lat/Long)',
            // WMS / Operacional
            wmsigdepto: 'Identificador de Departamento (WMS)',
            wmsigsetor: 'Identificador de Setor (WMS)',
            wmsosauto: 'OS Automática (WMS)',
            wmsconf: 'Configuração WMS',
            tipoestoque: 'Tipo de Estoque',
            confendereco: 'Conferência de Endereço',
            tipovol: 'Tipo de Volume',
            geraped: 'Gera Pedido',
            avisentr: 'Aviso de Entrada',
            naturezapadrao: 'Natureza Padrão',
            // Financeiro / Frete
            fretecota: 'Frete Cotação',
            emailcota: 'E-mail de Cotação',
            customeli: 'Custo Mercado Livre',
            ultnsu: 'Último NSU',
            ultconsmeli: 'Última Consulta Mercado Livre',
            // Webhook
            urlwebhook: 'URL Webhook',
            // Tomador
            cnpj_tomador: 'CNPJ Tomador',
            nome_tomador: 'Nome Tomador',
            // Observações
            obsadicionais: 'Observações Adicionais',
            // Interface
            layout: 'Layout',
            width: 'Largura',
            sidebar: 'Barra Lateral',
          }

          const erros = err.response?.data?.errors

          // Erro de validação do Laravel: errors é um objeto { campo: [mensagens] }
          if (erros && typeof erros === 'object' && !Array.isArray(erros)) {
            let listaErros = []
            Object.keys(erros).forEach(key => {
              listaErros.push({
                titulo: camposNomes[key] || key,
                mensagem: erros[key]
              })
            })
            this.errosValid = listaErros
            return
          }

          // Erro SQL ou exceção genérica: errors é uma string
          const msgErro = typeof erros === 'string' ? erros : (err.response?.data?.message || '')

          const matchTooLong = msgErro.match(/Data too long for column '(\w+)'/i)
          if (matchTooLong) {
            const coluna = matchTooLong[1]
            const nomeCampo = camposNomes[coluna] || coluna
            Swal.fire({
              icon: 'error',
              title: 'Texto muito longo',
              text: `O campo "${nomeCampo}" ultrapassa o limite de caracteres permitido. Por favor, encurte o texto e tente novamente.`,
            })
            return
          }

          // Qualquer outro erro 500
          Swal.fire({
            icon: 'error',
            title: 'Erro ao salvar',
            text: msgErro || 'Ocorreu um erro inesperado. Tente novamente.',
          })
        })



      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor preencher código e nome antes de salvar a empresa",
          showConfirmButton: false,
          timer: 1500
        })
      }


    },

    updateInstrucoesBoletoEquivalence() {
      if (this.equivalenceEditing.hub_class !== 'bancaria') return;

      let instrucoesPJ = (this.equivalenceEditing.instrucoes_boleto_pj || '').split(';');
      while (instrucoesPJ.length < 5) instrucoesPJ.push('');
      
      if (this.equivalenceEditing.juros_ativo) {
        if (!instrucoesPJ[0].includes('[$juros]')) instrucoesPJ[0] = instrucoesPJ[0].trim() ? instrucoesPJ[0] + ' [$juros]' : '[$juros]';
      }
      if (this.equivalenceEditing.multapj_ativo) {
        if (!instrucoesPJ[1].includes('[$multa]')) instrucoesPJ[1] = instrucoesPJ[1].trim() ? instrucoesPJ[1] + ' [$multa]' : '[$multa]';
      }
      if (this.equivalenceEditing.desconto_ativo) {
        if (!instrucoesPJ[2].includes('[$desconto]')) instrucoesPJ[2] = instrucoesPJ[2].trim() ? instrucoesPJ[2] + ' [$desconto]' : '[$desconto]';
      }
      this.equivalenceEditing.instrucoes_boleto_pj = instrucoesPJ.join(';');

      let instrucoesPF = (this.equivalenceEditing.instrucoes_boleto_pf || '').split(';');
      while (instrucoesPF.length < 5) instrucoesPF.push('');

      if (this.equivalenceEditing.juros_ativo) {
        if (!instrucoesPF[0].includes('[$juros]')) instrucoesPF[0] = instrucoesPF[0].trim() ? instrucoesPF[0] + ' [$juros]' : '[$juros]';
      }
      if (this.equivalenceEditing.multapf_ativo) {
        if (!instrucoesPF[1].includes('[$multa]')) instrucoesPF[1] = instrucoesPF[1].trim() ? instrucoesPF[1] + ' [$multa]' : '[$multa]';
      }
      if (this.equivalenceEditing.desconto_ativo) {
        if (!instrucoesPF[2].includes('[$desconto]')) instrucoesPF[2] = instrucoesPF[2].trim() ? instrucoesPF[2] + ' [$desconto]' : '[$desconto]';
      }
      this.equivalenceEditing.instrucoes_boleto_pf = instrucoesPF.join(';');
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())

      if(value){
        const format = "DD/MM/YYYY HH:mm:ss"
        var date = new Date(value);
        let dateTime = moment(date).format(format);
        // console.log(dateTime1)
        return dateTime
      }else{
        return null
      }
    }
  },
  mounted() {

    this.carregarDados()
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating" >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvar">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-warning" class="mx-2" :disabled="true">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Nova Permissão
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="showModalAtuLogo = true">
                <i class="bx bx-image-alt font-size-16 align-middle me-2"></i>
                Atualizar Logomarca
              </b-button>

<!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiarOrcamento">-->
<!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
<!--                Copiar-->
<!--              </b-button>-->

<!--              <b-button variant="outline-danger" class="mx-2" @click="cancelarOrcamento" :disabled="empresaData.status !== 'EL'" v-if="empresaData.status === 'EL'">-->
<!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
<!--                Cancelar Orçamento-->
<!--              </b-button>-->



              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

<!--              <button class="btn btn-success"-->
<!--                      @click="confirmarOrcamento"-->
<!--                      :disabled="empresaData.status !== 'EL'"-->
<!--                      v-if="empresaData.status === 'EL' && orctoItensData && orctoItensData.length > 0">-->
<!--                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!-->
<!--              </button>-->


            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="checkout-tabs" v-if="!updating">

      <b-card-text>
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title">Informações Principais</h4>-->
<!--            <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

            <form class="needs-validation">
              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="codigo">Código</label>
                    <input
                        id="codigo"
                        v-model="empresaData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código"
                        :disabled="empresaData.id && empresaData.id > 0"
                        :class="{'is-invalid': submitted && v$.empresaData.codigo.$error,}"/>
                    <div v-if="submitted && v$.empresaData.codigo.$error"
                         class="invalid-feedback">
                      <span v-if="v$.empresaData.codigo.required.$message">{{ v$.empresaData.codigo.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="nome">Nome de Exibição</label>
                    <input
                        id="nome"
                        v-model="empresaData.nome"
                        type="text"
                        class="form-control"
                        placeholder="Nome de Exibição"
                        :class="{'is-invalid': submitted && v$.empresaData.nome.$error,}"/>
                    <div v-if="submitted && v$.empresaData.nome.$error"
                         class="invalid-feedback">
                      <span v-if="v$.empresaData.nome.required.$message">{{ v$.empresaData.nome.required.$message }}</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="fantasia">Nome Fantasia</label>
                    <input
                        id="fantasia"
                        v-model="empresaData.fantasia"
                        type="text"
                        class="form-control"
                        maxlength="30"
                        placeholder="Nome Fantasia"
                        :class="{'is-invalid': submitted && v$.empresaData.fantasia.$error,}"/>
                    <div v-if="submitted && v$.empresaData.fantasia.$error"
                         class="invalid-feedback">
                      <span v-if="v$.empresaData.fantasia.required.$message">{{ v$.empresaData.fantasia.required.$message }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="razao">Razão Social</label>
                    <input
                        id="razao"
                        v-model="empresaData.razao"
                        type="text"
                        class="form-control"
                        placeholder="Razão Social"
                        :class="{'is-invalid': submitted && v$.empresaData.razao.$error,}"/>
                    <div v-if="submitted && v$.empresaData.razao.$error"
                         class="invalid-feedback">
                      <span v-if="v$.empresaData.razao.required.$message">{{ v$.empresaData.razao.required.$message }}</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-2">

                    <label for="cnpj">CNPJ</label>
                    <input
                        id="cnpj"
                        v-maska="'##.###.###/####-##'"
                        v-model="empresaData.cnpj"
                        type="text"
                        class="form-control"
                        placeholder="CNPJ"
                        :class="{'is-invalid': submitted && v$.empresaData.cnpj.$error,}"/>
                    <div v-if="submitted && v$.empresaData.cnpj.$error"
                         class="invalid-feedback">
                      <span v-if="v$.empresaData.cnpj.required.$message">{{ v$.empresaData.cnpj.required.$message }}</span>
                    </div>

                    <div class="chat-input-links" v-if="empresaData.cnpj">
                      <ul class="list-inline mb-0">
                        <li class="list-inline-item">
                          <a
                              @click="consultarCNPJ"
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Consultar CNPJ">
                            <i class="mdi mdi-cloud-search-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>


                </div>



                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="cep">CEP</label>
                    <div class="position-relative">
                      <input
                          id="cep"
                          v-maska="'##.###-###'"
                          v-model="empresaData.cep"
                          type="text"
                          class="form-control"
                          placeholder="CEP"/>
                      <div class="chat-input-links" v-if="empresaData.cnpj">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                @click="consultarCEP"
                                href="javascript: void(0);"
                                v-b-tooltip.hover
                                placement="top"
                                title="Consultar CEP">
                              <i class="mdi mdi-cloud-search-outline"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="rua">Endereço</label>
                    <div class="position-relative">
                      <input
                          id="rua"
                          v-model="empresaData.rua"
                          type="text"
                          class="form-control"
                          placeholder="Endereço"/>
                      <div class="chat-input-links" v-if="empresaData.rua">
                        <ul class="list-inline mb-0">
                          <li class="list-inline-item">
                            <a
                                @click="consultarEndereco"
                                href="javascript: void(0);"
                                v-b-tooltip.hover
                                placement="top"
                                title="Consultar Endereço">
                              <i class="mdi mdi-map"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="numero">Número</label>
                    <input
                        id="numero"
                        v-model="empresaData.numero"
                        type="text"
                        class="form-control"
                        placeholder="Número"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="compl">Complemento</label>
                    <input
                        id="compl"
                        v-model="empresaData.compl"
                        type="text"
                        class="form-control"
                        placeholder="Complemento"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="bairro">Bairro</label>
                    <input
                        id="bairro"
                        v-model="empresaData.bairro"
                        type="text"
                        class="form-control"
                        placeholder="Bairro"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="codmun">Código Cidade</label>
                    <input
                        id="codmun"
                        v-model="empresaData.codmun"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Código codmun"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">

                    <span class="font-size-13">Cidade </span>
                    <multiselect id="inputCidade"
                                 @search-change="pesqCidade"
                                 @select="escolheuCidade"
                                 v-model="empresaData.codmun"
                                 placeholder="Selecionar cidade"
                                 :options="dtListPesqCidade"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="codigo"
                                 class="mt-2">
                      <template #option="slotProps">
                        <div style="min-width: 25%;">
                              <span class="text-info">
                                {{ slotProps.option.estado }}
                              </span>
                        </div>
                        <div style="min-width: 300px;">
                              <span class="mx-4" >
                                {{ slotProps.option.descricao }}
                              </span>
                        </div>
                      </template>
                    </multiselect>

                  </div>
                </div>



                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="estado">Estado</label>
                    <input
                        id="estado"
                        v-model="empresaData.estado"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Estado"/>
                  </div>
                </div>



                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="inscricao">Inscrição</label>
                    <input
                        id="inscricao"
                        v-model="empresaData.inscricao"
                        type="text"
                        class="form-control"
                        placeholder="Inscrição"/>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="email">E-mail</label>
                    <input
                        id="email"
                        v-model="empresaData.email"
                        type="email"
                        class="form-control"
                        placeholder="E-mail"/>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="tel1">Telefone 1</label>
                    <input
                        id="tel1"
                        v-maska="'##.#####-####'"
                        v-model="empresaData.tel1"
                        type="text"
                        class="form-control"
                        placeholder="Telefone 1"/>
                  </div>
                </div>


                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="tel2">Telefone 2</label>
                    <input
                        id="tel2"
                        v-maska="'##.#####-####'"
                        v-model="empresaData.tel2"
                        type="text"
                        class="form-control"
                        placeholder="Telefone 2"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="cnae">CNAE</label>
                    <input
                        id="cnae"
                        v-model="empresaData.cnae"
                        type="text"
                        class="form-control"
                        placeholder="CNAE"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="tipoestab">Regime Tributário</label>
                    <select
                        id="tipoestab"
                        v-model="empresaData.regtrib"
                        class="form-control">
                      <option value="1">Simples Nacional</option>
                      <option value="2">Simples Nacional - excesso de sublimite da receita bruta</option>
                      <option value="3">Regime Normal</option>
                      <option value="99">Transportador</option>
                    </select>
                  </div>
                </div>



                <div class="col-sm-2">
                  <div class="mb-3 align-items-end align-content-end float-end">
                    <h5 class="font-size-14">Status</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="A"
                        unchecked-value="I"
                        v-model="empresaData.status">
                      {{ empresaData.status === 'A' ? 'Ativo' : 'Inativo' }}
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="mb-3 align-items-end align-content-end float-end">
                    <h5 class="font-size-14">Bloquear Automação</h5>
                    <b-form-checkbox
                        switch size="lg"
                        value="A"
                        unchecked-value="I"
                        v-model="empresaData.stsblauto">
                      {{ empresaData.stsblauto === 'A' ? 'Ativo' : 'Inativo' }}
                    </b-form-checkbox>
                  </div>
                </div>

              </div>

              <hr />


              <div class="row">

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="layout">Tipo de Layout</label>
                    <select
                        id="layout"
                        v-model="empresaData.layout"
                        class="form-control">
                      <option value="vertical">Vertical</option>
                      <option value="horizontal">Horizontal</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="width">Tamanho Horizontal do Layout</label>
                    <select
                        id="width"
                        v-model="empresaData.width"
                        class="form-control">
                      <option value="fluid">Padrão</option>
                      <option value="boxed">Caixa</option>
                      <option value="scrollable">Barra de Rolagem</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="width">Tipo de Barra Lateral</label>
                    <select
                        id="sidebar"
                        v-model="empresaData.sidebar"
                        class="form-control">
                      <option value="dark">Escuro</option>
                      <option value="light">Claro</option>
                      <option value="compact">Compacto</option>
                      <option value="icon">Ícone</option>
                      <option value="colored">Cores</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="customeli">Custo Mercado Livre (%)</label>
                    <input
                        id="customeli"
                        v-model="empresaData.customeli"
                        type="number"
                        class="form-control"
                        placeholder="Custo Mercado Livre"/>
                  </div>
                </div>


              </div>



            </form>

          </div>
        </div>




      </b-card-text>






      <b-card-text>
        <div class="card">
          <div class="card-body">
            <div class="card shadow-none border mb-0">
              <div class="card-body">
                <h4 class="card-title mb-4">Permissões e Parâmetros</h4>
<!--                <p class="card-title-desc">Veja abaixo as referências desta empresa</p>-->


                <div class="row" v-if="loadingRegras">
                  <div class="col-12 text-center">
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                    <b-spinner type="grow"
                               class="m-6 mx-2"
                               variant="secondary"
                               role="status">
                    </b-spinner>
                  </div>
                </div>



                <b-tabs pills fill content-class="p-3 text-muted" v-if="!updating">

                  <b-tab active class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">LOGOMARCA</span>
                    </template>

                    <div class="row" v-if="mediasData && mediasData[0]">

                      <div class="col-lg-6">
                        <b-card no-body >
                          <b-row no-gutters class="align-items-center">

                            <b-col md="4">
<!--                              <b-card-img :src="require('@/assets/images/small/img-2.jpg')" class="rounded-0"></b-card-img>-->
                              <b-card-img :src="blobUrlWhite" class="rounded-0" style="background-color: #8f9194"></b-card-img>
                            </b-col>
                            <b-col md="8">
                              <b-card-body title="Logo Tema Claro">
                                <b-card-text>Arquivo tamanho máximo de 200px x 200px, composição do header da plataforma com tema claro.</b-card-text>
                                <p class="card-text">
                                  <small class="text-muted"> {{ formatDateTime(mediasData[0].created_at) }} </small>
                                </p>
                              </b-card-body>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>


                      <div class="col-lg-6" v-if="mediasData && mediasData[1]">
                        <b-card no-body>
                          <b-row no-gutters class="align-items-center">
                            <b-col md="8">
                              <b-card-body title="Logo Tema Escuro">
                                <b-card-text>Arquivo tamanho máximo de 200px x 200px, composição do header da plataforma com tema escuro.</b-card-text>
                                <p class="card-text">
                                  <small class="text-muted"> {{ formatDateTime(mediasData[1].created_at) }} </small>
                                </p>
                              </b-card-body>
                            </b-col>
                            <b-col md="4">
                              <b-card-img :src="blobUrlBlack" class="rounded-0" style="background-color: white"></b-card-img>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>



                      <div class="col-lg-6" v-if="mediasData && mediasData[2]">
                        <b-card no-body >
                          <b-row no-gutters class="align-items-center">

                            <b-col md="4">
                              <b-card-img :src="blobUrlDanfe" class="rounded-0" style="background-color: #8f9194"></b-card-img>
                            </b-col>
                            <b-col md="8">
                              <b-card-body title="Logo Danfe (Nota Fiscal)">
                                <b-card-text>Arquivo tamanho máximo de 200px x 200px, composição do cabeçalho da nota fiscal.</b-card-text>
                                <p class="card-text">
                                  <small class="text-muted"> {{ formatDateTime(mediasData[2].created_at) }} </small>
                                </p>
                              </b-card-body>
                            </b-col>
                          </b-row>
                        </b-card>
                      </div>


                    </div>


                  </b-tab>

                  <b-tab class="border-0">
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">WMS</span>
                    </template>

                    <div class="row">

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">End. Ignorar Departamento</h5>
                          <b-form-checkbox
                              switch size="lg"
                              value="A"
                              unchecked-value="I"
                              v-model="empresaData.wmsigdepto">
                            {{ empresaData.wmsigdepto === 'A' ? 'Ativo' : 'Inativo' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">End. Ignorar Setor</h5>
                          <b-form-checkbox
                              switch size="lg"
                              value="A"
                              unchecked-value="I"
                              v-model="empresaData.wmsigsetor">
                            {{ empresaData.wmsigsetor === 'A' ? 'Ativo' : 'Inativo' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">Ordem Serviço Auto</h5>
                          <b-form-checkbox
                              switch size="lg"
                              value="A"
                              unchecked-value="I"
                              v-model="empresaData.wmsosauto">
                            {{ empresaData.wmsosauto === 'A' ? 'Automatico' : 'Manual' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">Permitir mudança na forma de conferência</h5>
                          <b-form-checkbox
                              switch size="lg"
                              value="NP"
                              unchecked-value="P"
                              v-model="empresaData.wmsconf">
                            {{ empresaData.wmsconf === 'P' ? 'Permitir' : 'Não permitir' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">Permitir editar volume após finalizar separação</h5>
                          <b-form-checkbox
                              switch
                              size="lg"
                              v-model="empresaData.editvolfinconf">
                            {{ empresaData.editvolfinconf ? 'Permitir' : 'Não Permitir'}}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="col-sm-2">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">Definir redirecionamento após finalizar separação</h5>
                          <b-form-checkbox
                              switch
                              size="lg"
                              v-model="empresaData.redfinconf">
                            {{ empresaData.redfinconf ? 'Para Próximo' : 'Para Grid'}}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                    <hr>

                    <h5>Configurações Estoque/Fluxo geração OS vs Pedidos</h5>
                    <div class="row">
                      <div class="col-3">
                          <div class="d-flex">
                            <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="mostrarHelp('fluxosaida')"></i>
                            <h5 class="font-size-14">Fluxo geração OS ou Pedido</h5>
                          </div>
                          <select
                              id="geraped"
                              v-model="empresaData.geraped"
                              class="form-control">
                            <option value="ORC">Pedido (Default)</option>
                            <option value="OS">Ordem de Saída</option>
                          </select>
                      </div>

                      <div class="col-3">
                        <div class="d-flex">
                          <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="mostrarHelp('volume')"></i>
                          <h5 class="font-size-14">Geração de volumes</h5>
                        </div>
                        <select
                            id="tipovol"
                            v-model="empresaData.tipovol"
                            class="form-control">
                          <option value="MANUAL">Manual</option>
                          <option value="AUTO">Automático(Cria 1 volume)</option>
                        </select>
                      </div>

                      <div class="col-3">
                          <div class="d-flex">
                            <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="mostrarHelp('estoque')"></i>
                            <h5 class="font-size-14">Tipo de movimentação de estoque</h5>
                          </div>
                          <select
                              id="geraped"
                              v-model="empresaData.tipoestoque"
                              class="form-control">
                            <option value="PADRAO">Padrão (Default)</option>     <!-- Cada saída de saldo deve conter saldo disponível para o produto -->
                            <option value="DESCON">Não verifica saldo, apenas registra movimentações</option> <!-- Não registra saldo atual, apenas entradas e saídas -->
                            <option value="NEGAT" disabled>Negativação</option>     <!-- Registra saldo negativo para poder realizar quitação posteriormente -->
                          </select>
                      </div>

                      <div class="col-sm-3">
                          <div class="d-flex">
                            <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="mostrarHelp('endereco')"></i>
                            <h5 class="font-size-14">Considerar endereço</h5>
                          </div>
                          <select
                              id="confendereco"
                              v-model="empresaData.confendereco"
                              class="form-control">
                            <option value="empresa" selected title="Considerar endereços por empresa">Por empresa (Default)</option>
                            <option value="todos" title="Considerar todos endereços para todas as empresas">Todas as empresas</option>
                          </select>
                      </div>

                      <div class="col-sm-3">
                        <div class="d-flex">
                          <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="mostrarHelp('natureza')"></i>
                          <h5 class="font-size-14">Definir Natureza Padrão</h5>
                          <b-form-checkbox
                              id="checkboxnatureza"
                              ref="checkboxnatureza"
                              switch
                              size="md"
                              class="ms-auto me-1"
                              @change="onChangeCheckbox"
                              @blur="mudouCheckboxNatureza"
                              v-model="checkboxNatureza">
                            {{ checkboxNatureza === true ? 'true' : 'false' }}
                          </b-form-checkbox>
                        </div>
                        <select
                            id="naturezapadrao"
                            ref="naturezapadrao"
                            v-model="empresaData.naturezapadrao"
                            @change="salvar"
                            :disabled="checkboxNatureza === false"
                            class="form-control">
                            <option disabled value="">Selecione a natureza padrão</option>
                            <option
                                v-for=" item in naturezasList"
                                :key="item.id"
                                :value="item.id"
                            >
                              {{ item.descricao }}
                            </option>
                        </select>
                      </div>
                    </div>

                    <hr>

                    <h5>Configurações disparo avisos</h5>
                    <div class="row">
                      <div class="col-sm-3">
                        <div class="mb-3 align-items-start align-content-start float-start">
                          <h5 class="font-size-14">Aviso de Entrega</h5>
                          <div class="col-sm-3" style="width: 250px;">
                            <multiselect
                                id="geraped"
                                v-model="empresaDatas.avisentr"
                                :options="opcoesAvisos"
                              @select="escolheuAviso"
                                mode="tags"
                                :close-on-select="false"
                                placeholder="Selecione os avisos"
                                label="text"
                                track-by="value">
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mt-5">

                      <h5>Baixa de estoque</h5>

                    </div>


                    <div class="row">

                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex align-items-start">


                              <b-button variant="outline-primary" class="mx-2" @click="novoEndereco">
                                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                Novo Endereço
                              </b-button>





                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">


                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Endereço</th>
                            <th scope="col">Usuário</th>
                            <th scope="col">Data</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>


                          <tr v-for="data in wmsEnderecosData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                                    <span class="text-dark">
                                                      {{ data.id }}
                                                    </span>
                              </h5>
                            </td>
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                                    <span class="text-dark">
                                                      {{ data.wmsender }}
                                                    </span>
                              </h5>
                            </td>
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                                    <span class="text-dark">
                                                      {{ data.created_by }}
                                                    </span>
                              </h5>
                            </td>
                            <td>{{ data.created_at }}</td>

                            <td>
                              <div class="button-items">


                                <b-button variant="outline-danger" @click="deletarWmsEndereco(data.id)" :disabled="data.email === 'admin@admin.com.br'">
                                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                </b-button>

                              </div>
                            </td>

                          </tr>

                          </tbody>
                        </table>
                      </div>

                    </div>

                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">ERP</span>
                    </template>

                    <div class="row">
                      <!-- Natureza Padrão e Obs -->
                      <div class="col-12">
                        <div class="card shadow-none border">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="d-flex align-items-center mb-2">
                                  <i class="bx bx-help-circle font-size-16 me-2" style="cursor:pointer"
                                    @click="mostrarHelp('natureza')"></i>
                                  <h5 class="font-size-14 mb-0">Natureza Padrão</h5>
                                  <b-form-checkbox id="checkboxnatureza" switch size="md" class="ms-auto"
                                    v-model="checkboxNatureza">
                                  </b-form-checkbox>
                                </div>
                                <select id="naturezapadrao" v-model="empresaData.naturezapadrao" @change="salvar"
                                  :disabled="!checkboxNatureza" class="form-control">
                                  <option disabled value="">Selecione a natureza padrão</option>
                                  <option v-for="item in naturezasList" :key="item.id" :value="item.id">
                                    {{ item.descricao }}
                                  </option>
                                </select>
                              </div>
                              <div class="col-md-8">
                                <h5 class="font-size-14">Observações Adicionais (ERP)</h5>
                                <textarea v-model="empresaData.obsadicionais" rows="2" class="form-control"
                                  placeholder="Ex: Observações para nota fiscal" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3 mt-2">
                      <div class="col-12 d-flex justify-content-between align-items-center">
                        <h4 class="card-title mb-0">Dados Fiscais Avançados</h4>
                        <b-button variant="success" @click="salvarRegraEmprFiscal" :disabled="updating">
                          <i class="bx bx-save font-size-16 align-middle me-2"></i> Salvar Dados Fiscais
                        </b-button>
                      </div>
                    </div>

                    <div class="row">
                      <!-- 1. Identificação Fiscal -->
                      <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-none border">
                          <div class="card-body">
                            <h5 class="card-title mb-3 border-bottom pb-2"><i
                                class="bx bx-id-card me-2"></i>Identificação Fiscal</h5>
                            <div class="row">
                              <div class="col-6 mb-3">
                                <label>Inscrição Municipal</label>
                                <input v-model="emprfiscalData.im" class="form-control" placeholder="IM" />
                              </div>
                              <div class="col-6 mb-3">
                                <label>CNPJ (Empresa)</label>
                                <input :value="empresaData.cnpj" readonly
                                  class="form-control-plaintext font-weight-bold" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 2. Regime Tributário -->
                      <div class="col-md-6 mb-4">
                        <div class="card h-100 shadow-none border">
                          <div class="card-body">
                            <h5 class="card-title mb-3 border-bottom pb-2"><i class="bx bx-tachometer me-2"></i>Regime e
                              Enquadramento</h5>
                            <div class="row">
                              <div class="col-12 mb-3">
                                <label>Regime Tributário (PIS/COFINS)</label>
                                <select v-model="emprfiscalData.regime_pis_cofins" class="form-control">
                                  <option value="">Selecione...</option>
                                  <option value="1">Cumulativo</option>
                                  <option value="2">Não Cumulativo</option>
                                </select>
                              </div>
                              <div class="col-6 mb-3">
                                <label>Contribuinte ICMS</label>
                                <select v-model="emprfiscalData.ind_icms" class="form-control">
                                  <option value="1">Contribuinte</option>
                                  <option value="2">Isento</option>
                                  <option value="9">Não Contribuinte</option>
                                </select>
                              </div>
                              <div class="col-6 mb-3">
                                <label>Contribuinte IPI</label>
                                <select v-model="emprfiscalData.ind_ipi" class="form-control">
                                  <option value="1">Sim</option>
                                  <option value="0">Não</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 3. Parâmetros de Impostos -->
                      <div class="col-12 mb-4">
                        <div class="card shadow-none border">
                          <div class="card-body">
                            <h5 class="card-title mb-3 border-bottom pb-2"><i
                                class="bx bx-calculator me-2"></i>Parâmetros de Impostos (Padrão)</h5>
                            <b-tabs pills small class="fiscal-sub-tabs">
                              <b-tab title="ICMS" active>
                                <div class="row mt-3">
                                  <div class="col-md-3 mb-3"><label>CST ICMS</label><input
                                      v-model="emprfiscalData.cst_icms_padrao" class="form-control" maxlength="3" />
                                  </div>
                                  <div class="col-md-3 mb-3"><label>Alíquota (%)</label><input type="number"
                                      v-model="emprfiscalData.aliq_icms_padrao" class="form-control" step="0.01" />
                                  </div>
                                  <div class="col-md-3 mb-3"><label>FCP (%)</label><input type="number"
                                      v-model="emprfiscalData.fcp_icms_padrao" class="form-control" step="0.01" /></div>
                                  <div class="col-md-3 mb-3"><label>MVA (%)</label><input type="number"
                                      v-model="emprfiscalData.mva_icms_padrao" class="form-control" step="0.01" /></div>
                                  <div class="col-md-4 mt-2">
                                    <b-form-checkbox switch v-model="emprfiscalData.ctrl_ciap">Controle
                                      CIAP</b-form-checkbox>
                                  </div>
                                  <div class="col-md-4 mb-3" v-if="emprfiscalData.ctrl_ciap"><label>% Prop.
                                      ICMS</label><input type="number" v-model="emprfiscalData.perc_prop_icms"
                                      class="form-control" /></div>
                                  <div class="col-md-4 mb-3" v-if="emprfiscalData.ctrl_ciap"><label>% CIAP
                                      Mês</label><input type="number" v-model="emprfiscalData.perc_ciap_mes"
                                      class="form-control" /></div>
                                </div>
                              </b-tab>
                              <b-tab title="IPI">
                                <div class="row mt-3">
                                  <div class="col-md-4 mb-3"><label>CST IPI</label><input
                                      v-model="emprfiscalData.cst_ipi_padrao" class="form-control" maxlength="3" />
                                  </div>
                                </div>
                              </b-tab>
                              <b-tab title="PIS/COFINS">
                                <div class="row mt-3">
                                  <div class="col-md-3 mb-3"><label>CST PIS (Saída)</label><input
                                      v-model="emprfiscalData.cst_pis_saida" class="form-control" /></div>
                                  <div class="col-md-3 mb-3"><label>Alíq PIS (%)</label><input type="number"
                                      v-model="emprfiscalData.aliq_pis_saida" class="form-control" /></div>
                                  <div class="col-md-3 mb-3"><label>CST PIS (Entrada)</label><input
                                      v-model="emprfiscalData.cst_pis_ent" class="form-control" /></div>
                                  <div class="col-md-3"></div>
                                  
                                  <div class="col-md-3 mb-3"><label>CST COFINS (Saída)</label><input
                                      v-model="emprfiscalData.cst_cofins_saida" class="form-control" /></div>
                                  <div class="col-md-3 mb-3"><label>Alíq COFINS (%)</label><input type="number"
                                      v-model="emprfiscalData.aliq_cofins_saida" class="form-control" /></div>
                                  <div class="col-md-3 mb-3"><label>CST COFINS (Entrada)</label><input
                                      v-model="emprfiscalData.cst_cofins_ent" class="form-control" /></div>
                                </div>
                              </b-tab>
                              <b-tab title="ISSQN">
                                <div class="row mt-3">
                                  <div class="col-md-4 mb-3"><label>Alíquota ISSQN (%)</label><input type="number"
                                      v-model="emprfiscalData.aliq_issqn_padrao" class="form-control" /></div>
                                  <div class="col-md-4 mb-3"><label>Cód. Serviço</label><input
                                      v-model="emprfiscalData.cod_servico_padrao" class="form-control" /></div>
                                  <div class="col-md-4 mb-3">
                                    <label>Local Incidência</label>
                                    <select v-model="emprfiscalData.local_issqn_padrao" class="form-control">
                                      <option value="1">No Município</option>
                                      <option value="2">Fora do Município</option>
                                    </select>
                                  </div>
                                </div>
                              </b-tab>
                            </b-tabs>
                          </div>
                        </div>
                      </div>

                      <!-- 4. Obrigações Acessórias -->
                      <div class="col-md-7 mb-4">
                        <div class="card h-100 shadow-none border">
                          <div class="card-body">
                            <h5 class="card-title mb-3 border-bottom pb-2"><i class="bx bx-briefcase me-2"></i>Contador
                              e SPED</h5>
                            <div class="row">
                              <div class="col-md-6 mb-3"><label>Nome do Contador</label><input
                                  v-model="emprfiscalData.contador_nome" class="form-control" /></div>
                              <div class="col-md-6 mb-3"><label>E-mail do Contador</label><input
                                  v-model="emprfiscalData.contador_email" class="form-control" /></div>
                              <div class="col-md-6 mb-3"><label>CPF</label><input v-model="emprfiscalData.contador_cpf"
                                  class="form-control" v-maska="'###.###.###-##'" /></div>
                              <div class="col-md-6 mb-3"><label>CRC</label><input v-model="emprfiscalData.contador_crc"
                                  class="form-control" /></div>
                              <div class="col-12 mt-2">
                                <h6>Gerar Blocos SPED:</h6>
                                <div class="d-flex flex-wrap gap-3">
                                  <b-form-checkbox v-model="emprfiscalData.gerar_bloco_k">Bloco K</b-form-checkbox>
                                  <b-form-checkbox v-model="emprfiscalData.gerar_bloco_g">Bloco G</b-form-checkbox>
                                  <b-form-checkbox v-model="emprfiscalData.gerar_bloco_m">Bloco M</b-form-checkbox>
                                  <b-form-checkbox v-model="emprfiscalData.gerar_bloco_c">Bloco C</b-form-checkbox>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 5. Emissão NFe -->
                      <div class="col-md-5 mb-4">
                        <div class="card h-100 shadow-none border">
                          <div class="card-body">
                            <h5 class="card-title mb-3 border-bottom pb-2"><i class="bx bx-file me-2"></i>Emissão NF-e
                            </h5>
                            <div class="row">
                              <div class="col-8 mb-3">
                                <label>Ambiente</label>
                                <b-form-radio-group v-model="emprfiscalData.ativadoambprod"
                                  :options="[{ text: 'Homologação', value: false }, { text: 'Produção', value: true }]"
                                  buttons button-variant="outline-primary" size="sm" class="w-100"></b-form-radio-group>
                              </div>
                              <div class="col-4 mb-3">
                                <label>Modelo</label>
                                <select v-model="emprfiscalData.modelo" class="form-control">
                                  <option :value="55">[55] NF-e</option>
                                  <option :value="65" disabled>[65] NFC-e</option>
                                  <option :value="57" disabled>[57] CT-e</option>
                                </select>
                              </div>
                              <div class="col-6 mb-3">
                                <label>Série Padrão</label>
                                <input v-model="emprfiscalData.serie_nfe_padrao" class="form-control" maxlength="3" />
                              </div>
                              <div class="col-6 mb-3">
                                <label>Tipo Emissão</label>
                                <select v-model="emprfiscalData.tp_emis_padrao" class="form-control">
                                  <option value="1">Normal</option>
                                  <option value="9">Contingência</option>
                                </select>
                              </div>
                              <div class="col-12">
                                <label>E-mails para Alertas NF-e</label>
                                <input v-model="emprfiscalData.email_alertas_nfe" class="form-control"
                                  placeholder="Separar por vírgula" />
                              </div>
                              <div class="col-12 mt-3" v-if="emprfiscalData.ativadoambprod !== undefined">
                                <label>Nº Última Nota ({{ emprfiscalData.ativadoambprod ? 'Prod' : 'Homol' }})</label>
                                <input
                                  v-model="emprfiscalData[emprfiscalData.ativadoambprod ? 'ultimanotaprod' : 'ultimanotahmg']"
                                  type="number" class="form-control" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label>Criado em:</label>
                          <input :value="emprfiscalData.created_at" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="mb-3">
                          <label>Atualizado em:</label>
                          <input :value="emprfiscalData.updated_at" readonly class="form-control" />
                        </div>
                      </div>
                    </div>

                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">FRETES</span>
                    </template>

                    <div v-if="paramTomador === 'INSERT_TOMADOR'" class="row">
                      <div class="card">
                        <div class="card-body">

                          <h5 class="mb-3">Tomador do Frete</h5>
                          <div class="row mb-2">
                            <div class="col-md-4">
                              <label for="cnpjtomador">CNPJ Tomador</label>
  <!--                            <label for="cnpj" v-else>CPF</label>-->
                              <div class="position-relative">
                                <input id="cnpjtomador" v-maska="'##.###.###/####-##'"
                                       type="text" v-model="empresaData.cnpj_tomador" class="form-control" placeholder="CNPJ"/>
                                <div class="chat-input-links" v-if="empresaData.cnpj_tomador">
                                  <ul class="list-inline mb-0">
                                    <li class="list-inline-item">
                                      <a @click="consultarCNPJTomador" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                         title="Consultar CNPJ">
                                        <i class="mdi mdi-cloud-search-outline"></i>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div class="col-sm-4">
                              <div class="mb-3">
                                <label for="nometomador">Nome Tomador</label>
                                <input id="nomenometomador" v-model="empresaData.nome_tomador" type="text" class="form-control" placeholder="Nome" :disabled= true />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row">
                      <div class="card">
                        <div class="card-body">

                          <h5 class="mb-3">Seguimento do Frete</h5>
                          <div class="d-flex align-items-start mb-4">
                            <b-button variant="outline-primary" @click="showFormSegtoFrete = true; dtListPesqFreteCota = null">
                              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                              Novo Seguimento de Frete
                            </b-button>
                          </div>


                          <div class="d-flex justify-content-between">
                            <div class="col-md-4">
                              <div class="mb-3">
                                <span>Seguimento de Frete (Principal)</span>

                                <multiselect id="fretecota"
                                             class="mt-2"
                                             @search-change="pesqFreteCota"
                                             @select="escolheuFreteCota"
                                             v-model="empresaData.fretecota"
                                             placeholder="Pesquisar seguimento"
                                             :options="dtListPesqFreteCota"
                                             :searchable="true"
                                             label="nome"
                                             track-by="nome"
                                             value-prop="codigo">
                                  <template #option="slotProps">
                                    <div class="row">
                                      <div>
                                    <span class="text-info">
                                      {{ slotProps.option.codigo }}
                                    </span>
                                        <span class="mx-4" >

                                    </span>
                                      </div>
                                      <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                                      <span class="mx-4" >
                                  </span>
                                      <span class="mx-4" >
                                  </span>
                                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

                                    </div>
                                  </template>
                                </multiselect>

                              </div>
                            </div>

                            <div class="col-md-6">
                              <div class="mb-3">
                                <label for="emailcota">E-mail contratação</label>
                                <input
                                    id="emailcota"
                                    v-model="empresaData.emailcota"
                                    type="email"
                                    class="form-control"
                                    placeholder="E-mail contratação"/>
                              </div>
                            </div>
                          </div>

                          <div class="row my-4">
                            <h5>Segmentos cadastrados</h5>
                            <div class="table-responsive">
                              <table class="table align-middle mb-0 table-nowrap">
                                <thead class="table-light">
                                <tr>
                                  <th scope="col">ID</th>
                                  <th scope="col">Código</th>
                                  <th scope="col">Descrição</th>
                                  <th scope="col">Criado em</th>
                                  <th scope="col">Ações</th>
                                </tr>
                                </thead>
                                <tbody>


                                <tr v-for="data in emprSegtosData" :key="data.id">

                                  <td>
                                    <h5 class="font-size-14 text-truncate" @click="editarToken(data.id)">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                                    </h5>
                                  </td>

                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.codigo }}
                                </span>
                                    </h5>
                                  </td>

                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.nome }}
                                </span>
                                    </h5>
                                  </td>

                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.created_at }}
                                </span>
                                    </h5>
                                  </td>


                                  <td>
                                    <div class="button-items">

                                      <b-button variant="outline-danger" @click="deletarEmprSegto(data.id)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                      </b-button>


                                    </div>
                                  </td>

                                </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="row">
                      <div class="card">
                        <div class="card-body">

                          <h5 class="mb-3">Origens de Cotações</h5>
                          <div class="d-flex align-items-start mb-4">
                            <b-button variant="outline-primary" @click="showFormOrigem = true; emprOrigemData = {}; submittedEmprOrigem = false;">
                              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                              Nova Origem Cotação
                            </b-button>
                          </div>

                          <div class="row my-4">
                            <h5>Origens cadastradas</h5>
                            <div class="table-responsive">
                              <table class="table align-middle mb-0 table-nowrap">
                                <thead class="table-light">
                                <tr>
                                  <th scope="col">ID</th>
                                  <th scope="col">CEP</th>
                                  <th scope="col">Rua</th>
                                  <th scope="col">Número</th>
                                  <th scope="col">Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="data in emprOrigensData" :key="data.id">
                                  <td>
                                    <h5 class="font-size-14 text-truncate" @click="editarOrigem(data)">
                                      <span class="text-dark">
                                        {{ data.id }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.cep }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.rua }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.numero }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <div class="button-items">
                                      <b-button variant="outline-danger" @click="deletarEmprOrigem(data.id)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                      </b-button>
                                    </div>
                                  </td>

                                </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>




                    <div class="row">
                      <div class="card">
                        <div class="card-body">

                          <h5 class="mb-3">Regras de Frete</h5>
                          <div class="d-flex align-items-start mb-4">
                            <b-button variant="outline-primary" @click="showFormRegraFrete = true; regraFreteData = {}; submittedRegraFrete = false;">
                              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                              Nova Regra Frete
                            </b-button>
                          </div>

                          <div class="row my-4">
                            <h5>Regras cadastradas</h5>
                            <div class="table-responsive">
                              <table class="table align-middle mb-0 table-nowrap">
                                <thead class="table-light">
                                <tr>
                                  <th scope="col">ID</th>
                                  <th scope="col">TIPO</th>
                                  <th scope="col">Origem</th>
                                  <th scope="col">Destino</th>
                                  <th scope="col">Transportadora</th>
                                  <th scope="col text-end">Valor</th>
                                  <th scope="col">Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="data in regrasFretesData" :key="data.id">
                                  <td>
                                    <h5 class="font-size-14 text-truncate" @click="editarRegraFrete(data)">
                                      <span class="text-dark">
                                        {{ data.id }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.tipo }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.origem }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.destino }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.cnpjtransp }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td class="text-end">
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.valor }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <div class="button-items">
                                      <b-button variant="outline-danger" @click="deletarRegraFrete(data.id)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                      </b-button>
                                    </div>
                                  </td>

                                </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">CONTROLE DE ENTREGA</span>
                    </template>

                    <div class="row">
                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body gap-5">                                                           
                            <b-button variant="outline-primary" class="mx-2" @click="modalSLAEntrega()">
                              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                              Adicionar SLA
                            </b-button>

                          </div>

                          <div>
                            <h5>SLA de entrega cadastradas</h5>
                            <div class="table-responsive">
                              <table class="table align-middle mb-0 table-nowrap">
                                <thead class="table-light">
                                <tr>
                                  <th scope="col">ID</th>
                                  <th scope="col">Dias</th>
                                  <th scope="col">Úteis/Corridos</th>
                                  <th scope="col">Cidades</th>
                                  <th scope="col">Ações</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="data in slaentregaData" :key="data.id">
                                  <td>
                                    <h5 class="font-size-14 text-truncate" @click="modalSLAEntrega(data)">
                                      <span class="text-dark">
                                        {{ data.id }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.diassla }}
                                      </span>
                                    </h5>
                                  </td>
                                  <td>
                                    <h5 class="font-size-14 text-truncate">
                                      <span class="text-dark">
                                        {{ data.diasuteis === 'CORRIDOS' ? 'Corridos' : 'Úteis' }}
                                      </span>
                                    </h5>
                                  </td>

                                  <td>
                                    <h5 class="font-size-14 text-truncate" @click="modalSLAEntrega(data)">
                                      <span class="text-dark" v-if="slaentregacidadesData.length > 0">
                                        {{ data.cidades }}
                                      </span>

                                      <span class="text-dark" v-else>Nenhuma cidade cadastrada</span>
                                      
                                    </h5>
                                  </td>
                                  <td>
                                    <div class="button-items">
                                      <b-button variant="outline-warning" @click="modalSLAEntrega(data)">
                                        <i class="mdi mdi-pencil d-block font-size-16"></i>
                                      </b-button>

                                      <b-button variant="outline-danger" @click="deletarSLAEntrega(data.id)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                      </b-button>
                                    </div>
                                  </td>

                                </tr>

                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">TOKENS</span>
                    </template>

                    <div class="row">

                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex align-items-start">

                              <b-button variant="outline-primary" class="mx-2" @click="triggerHubSelection('token')">
                                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                Novo Token
                              </b-button>

                              <b-button variant="outline-secondary" class="mx-2" @click="triggerHubSelection('equivalence')"
                              >
                                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                Nova Equivalencia
                              </b-button>

                              <b-button variant="outline-success" class="mx-2" @click="showModalCertDigital = true">
                                <i class="bx bx-file font-size-16 align-middle me-2"></i>
                                Novo Certificado Digital
                              </b-button>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">

                      <div class="table-responsive">
                        <h4>Tokens</h4>
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">HUB</th>
                            <th scope="col">Criado em</th>
                            <th scope="col">Validade Token(Access)</th>
                            <th scope="col">Validade Token(Refresh)</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>


                          <tr v-for="data in empreTokensData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate" @click="editarToken(data.id)">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.hub }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDateTime(data.created_at) }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDateTime(data.actokenvalid) }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDateTime(data.rftokenvalid) }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <div class="button-items">

                                <b-button variant="outline-danger" @click="deletarEmprToken(data.id)">
                                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                </b-button>

                                <b-button variant="outline-warning" @click="editarToken(data.id)">
                                  <i class="mdi mdi-pencil d-block font-size-16"></i>
                                </b-button>

                                <b-button variant="light"
                                          v-if="(data.cliid != null && data.clisecret != null) && (data.actoken == null && data.rftoken == null)"
                                          :disabled="data.actoken != null && data.rftoken != null"
                                          @click="ativaHub(data.hub)"
                                >
                                  <i class="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                  Ativar hub
                                </b-button>

                                <b-button variant="success"
                                          :if="data.cliid != null && data.clisecret != null"
                                          :disabled="true"
                                          v-if="data.actoken && data.rftoken"
                                >
                                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                                  Hub ativado
                                </b-button>

                                <b-button variant="success"
                                          v-if="data.cliid == null && data.clisecret == null && !data.is_equivalence"
                                          :disabled="true"
                                >
                                  <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                                  Sem ativação
                                </b-button>

                                <b-button variant="warning"
                                          v-if="data.is_equivalence"
                                          :disabled="true"
                                > 
                                
                                  <i class="bx bx-book font-size-16 align-middle me-2"></i>
                                  Equivalencia
                                </b-button>

                              </div>
                            </td>

                          </tr>

                          </tbody>
                        </table>
                      </div>

                      <hr>

                      <div class="table-responsive mt-4">
                          <h4 class="col-sm-2">Certificados Digitais</h4>

                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Tipo</th>
                            <th scope="col">Nome</th>
                            <th scope="col">Validade</th>
                            <th scope="col">Criado por</th>
                            <th scope="col">Criado em</th>
                            <th scope="col">Ambiente</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>


                          <template v-if="empreCertDigList && empreCertDigList.length > 0">
                            <tr v-for="data in empreCertDigList" :key="data.id">
                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.tipo }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.nome }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDate(data.validade) }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.created_by }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDate(data.created_at) }}
                                </span>
                                </h5>
                              </td>

                              <td>
                                <div class="mb-3 align-items-start align-content-start float-start">
                                    <h5 class="font-size-14">Ambiente:</h5>
                                    <b-form-checkbox
                                        @change="salvaCertDig(data)"
                                        switch
                                        size="lg"
                                        v-model="data.ativadoambprod">
                                      {{ data.ativadoambprod ? 'Produção' : 'Homologação'}}
                                    </b-form-checkbox>
                                </div>
                              </td>

                              <td>
                                <div class="button-items">

                                  <b-button variant="outline-danger" @click="deletarCertDig(data.id)">
                                    <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                  </b-button>

                                  <!--
                                  <b-button variant="outline-warning" @click="editarCertDig(data)">
                                    <i class="mdi mdi-pencil d-block font-size-16"></i>
                                  </b-button>-->

                                </div>
                              </td>
                            </tr>
                          </template>

                          <template v-else>
                            <tr>
                              <td colspan="7">
                                <b-alert show variant="warning" class="justify-content-center">
                                  Sem nenhum certificado cadastrado por aqui!
                                </b-alert>
                              </td>
                            </tr>
                          </template>
                          </tbody>
                        </table>
                      </div>

                    </div>



                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">WEBHOOK</span>
                    </template>

                    <b-card-text>
                      <div class="card">
                        <div class="col-sm-5">
                          <div class="mb-3 align-items-center align-content-center">
                            <h5 class="font-size-14">Status</h5>
                            <div class="col-md-2">
                              <div class="mb-3">
                                <b-form-checkbox
                                    class="d-flex"
                                    switch size="lg"
                                    v-model="empresaData.ativawebhook"
                                    @click="ativawebhook">
                                  {{ empresaData.ativawebhook === true ? 'Ativo' : 'Inativo' }}
                                </b-form-checkbox>
                              </div>
                            </div>


                            <div class="col-md-10 mr-3">
                              <div class="mb-3">
                                <label for="urlwebhook">URL para callbacks</label>
                                <input
                                    id="urlwebhook"
                                    v-model="empresaData.urlwebhook"
                                    type="text"
                                    class="form-control"
                                    placeholder="URL callback"/>
                              </div>
                            </div>

                            <b-button variant="outline-dark d-flex" @click="testarwebhook">Testar URL</b-button>
                          </div>
                        </div>
                      </div>
                    </b-card-text>
                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">PARÂMETROS</span>
                    </template>

                    <div class="row">

                      <div class="col-lg-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="d-flex align-items-start">

                              <b-button variant="outline-primary" class="mx-2" @click="novoEmprParam">
                                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                Novo Parâmetro
                              </b-button>

                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                    <div class="row">
                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Valor</th>
                            <th scope="col">Código</th>
                            <th scope="col">Data</th>
                            <th scope="col">Criado em</th>
                            <th scope="col">Usuário</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>


                          <tr v-for="data in emprParamsData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate" @click="editarToken(data.id)">
                                <span class="text-dark">
                                  {{ data.id }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDescricaoParam(data) }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.valor }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.codigo }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ formatDate(data.data) }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.created_at }}
                                </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <span class="text-dark">
                                  {{ data.created_by }}
                                </span>
                              </h5>
                            </td>


                            <td>
                              <div class="button-items">
                                <b-button variant="outline-success" @click="editarEmprParam(data)">
                                  <i class="mdi mdi-pencil d-block font-size-16"></i>
                                </b-button>
                                <b-button variant="outline-danger" @click="deletarEmprParam(data.id)">
                                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                </b-button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                    </div>



                  </b-tab>

                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-cog"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">FINANCEIRO</span>
                    </template>

                    <b-tabs pills justified content-class="p-3 text-muted" v-if="!updating">
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="fas fa-cog"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">Cobrança</span>
                        </template>

                        <div class="row">
                          <div class="col-lg-12">
                            <div class="card">
                              <div class="card-body">
                                <div class="d-flex align-items-start">
                                  <b-button variant="outline-success" class="mx-2" @click="salvarRegraCobranca">
                                    <i class="bx bx-save font-size-16 align-middle me-2"></i>
                                    Salvar regra
                                  </b-button>

                                  <b-button :variant="dropzoneFile !== null ? 'outline-primary' : 'outline-success'" class="mx-2" @click="showModalLogoCobranca = true">
                                    <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                    Logo para cobranças
                                  </b-button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-12 mb-2">
                            <div class="d-flex flex-wrap gap-4">

                              <div class="col-3">
                                <label for="pessoafisicperc">Percentual multa para pessoa física:</label>
                                <input
                                    id="pessoafisicperc"
                                    v-model="emprparamcobranca.pessoafisicperc"
                                    type="number"
                                    class="form-control w-50"
                                />
                              </div>

                              <div class="col-3">
                                <label for="pessoajuricperc">Percentual multa para pessoa jurídica:</label>
                                <input
                                    id="pessoajuricperc"
                                    v-model="emprparamcobranca.pessoajuricperc"
                                    type="number"
                                    class="form-control w-50"
                                />
                              </div>

                              <div class="col-3">
                                <label class="form-label d-block">Avisar com antecedência</label>
                                <b-form-checkbox
                                    switch size="lg"
                                    value="true"
                                    unchecked-value="false"
                                    v-model="emprparamcobranca.cobrantec">
                                  {{ emprparamcobranca.cobrantec === true ? 'Ativo' : 'Inativo' }}
                                </b-form-checkbox>
                              </div>

                              <div class="col-3" title="Quantidade de dias para se iniciar a cobrança a vencer">
                                <label for="qtddiasantec">Quantidade dias cobrança Antec.</label>
                                <input
                                    id="qtddiasantec"
                                    v-model="emprparamcobranca.qtddiasantec"
                                    type="number"
                                    class="form-control w-50"
                                />
                              </div>

                              <div class="col-3">
                                <label class="form-label d-block">Ativar cobrança após vencimento</label>
                                <b-form-checkbox
                                    switch size="lg"
                                    value="true"
                                    unchecked-value="false"
                                    v-model="emprparamcobranca.cobrvencida">
                                  {{ emprparamcobranca.cobrvencida === true ? 'Ativo' : 'Inativo' }}
                                </b-form-checkbox>
                              </div>

                              <div class="col-3" title="Quantidade de cobranças a realizar após vencimento do financeiro">
                                <label for="qtdcobrvencida">Quantidade</label>
                                <input
                                    id="qtdcobrvencida"
                                    v-model="emprparamcobranca.qtdcobrvencida"
                                    type="number"
                                    class="form-control w-50"
                                />
                              </div>

                              <div class="col-3" title="Canal de Envio">
                                <label for="meiocobranca">Canal de Envio</label>
                                <select id="meiocobranca" class="form-control w-50" v-model="emprparamcobranca.meio_cobranca">
                                  <option value="E">Email</option>
                                  <option value="W">WhatsApp</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div class="mb-3 mt-3">
                            <label>Texto Cobrança</label>
                            <div>
                          <textarea
                              v-model="emprparamcobranca.textocobr"
                              class="form-control preserve-format"
                              name="textarea"
                              rows="5"
                              placeholder="Texto para cobrança"
                          ></textarea>
                              <div
                                  v-if="emprparamcobranca.textocobr"
                                  class="invalid-feedback"
                              >
                                <span>Texto da cobrança é obrigatório!</span>
                              </div>
                            </div>
                          </div>

                          <div class="mb-3">
                            <label>Dados responsáveis</label>
                            <div>
                          <textarea
                              v-model="emprparamcobranca.dadosresponsavel"
                              class="form-control preserve-format"
                              name="textarea"
                              rows="3"
                              placeholder="Dados setor de cobrança ou responsável pela cobrança"
                          ></textarea>
                            </div>
                          </div>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="fas fa-cog"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">Acordos</span>
                        </template>

                        <h6 class="text-info">Em desenvolvimento...</h6>
                      </b-tab>
                    </b-tabs>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>

      </b-card-text>


    </div>


    <b-modal size="lg" title="Consultar CNPJ" v-model="showModalConsCNPJ" hide-footer>

      <div class="row" v-if="loadingDadosCnpj">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingDadosCnpj">
        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>

        <div class="row">
          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Situação Atual</p>
                    <h5 class="mb-0">{{ consCnpjSituacao }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Data de Abertura</p>
                    <h5 class="mb-0"> {{ consCnpjDAbe }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Sócio 01</p>
                    <h5 class="mb-0">{{ consCnpjSocio1 }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <div class="me-2">
                    <p class="text-muted mb-2">Sócio 02</p>
                    <h5 class="mb-0"> {{ consCnpjSocio2 }}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Nome Fantasia</span>
              <b-form-checkbox
                  v-model="consCnpjImpFantasia"
                  switch>
                {{ consCnpjFantasia }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Nome</span>
              <b-form-checkbox
                  v-model="consCnpjImpNome"
                  switch>
                {{ consCnpjNome }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>CNPJ</span>
              <b-form-checkbox
                  v-model="consCnpjImpCnpj"
                  switch>
                {{ consCnpjCnpj }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>CEP</span>
              <b-form-checkbox
                  v-model="consCnpjImpCep"
                  switch>
                {{ consCnpjCep }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Endereço</span>
              <b-form-checkbox
                  v-model="consCnpjImpEndereco"
                  switch>
                {{ consCnpjEndereco }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Número</span>
              <b-form-checkbox
                  v-model="consCnpjImpNumero"
                  switch>
                {{ consCnpjNumero }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Complemento</span>
              <b-form-checkbox
                  v-model="consCnpjImpCompl"
                  switch>
                {{ consCnpjCompl }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Bairro</span>
              <b-form-checkbox
                  v-model="consCnpjImpBairro"
                  switch>
                {{ consCnpjBairro }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Cidade</span>
              <b-form-checkbox
                  v-model="consCnpjImpCidade"
                  switch>
                {{ consCnpjCidade }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Estado</span>
              <b-form-checkbox
                  v-model="consCnpjImpEstado"
                  switch>
                {{ consCnpjEstado }}
              </b-form-checkbox>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>E-mail</span>
              <b-form-checkbox
                  v-model="consCnpjImpEmail"
                  switch>
                {{ consCnpjEmail }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Telefone 1</span>
              <b-form-checkbox
                  v-model="consCnpjImpTel"
                  switch>
                {{ consCnpjTel }}
              </b-form-checkbox>
            </div>
          </div>
        </div>



        <div v-if="!loadingEmpresa && emprePermisData">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalConsCNPJ = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarImpCnpj">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

          </div>
        </div>

      </div>

    </b-modal>

    <b-modal size="lg" title="SLA de Entrega" v-model="showModalSlaEntrega" hide-footer>
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-start gap-5">  

                <div class="mb-3 align-items-start align-content-start float-start ">
                  <h5 class="font-size-14">Dias de Entrega</h5>
                  <b-form-input
                      v-model="slaentrega.diassla"
                      placeholder="Dias"
                      type="number"
                      required>
                  </b-form-input>
                </div>

                <div class="mb-3 align-items-start align-content-start float-start">
                  <h5 class="font-size-14">Dias úteis</h5>
                  <b-form-checkbox
                      switch size="lg"
                      value="UTEIS"
                      unchecked-value="CORRIDOS"
                      v-model="slaentrega.diasuteis">
                    {{ slaentrega.diasuteis === 'UTEIS' ? 'Úteis' : 'Corridos' }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12 gap-5">
          <table class="table align-middle mb-0 table-nowrap">
            <thead class="table-light">
            <tr>
              <th scope="col">ID</th>
              
              <th scope="col">Cidade</th>
              <th scope="col">Estado</th>
              <th scope="col">IBGE</th>
              <th scope="col">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in slaentregacidades" :key="data.id">
              <td>
                <h5 class="font-size-14 text-truncate" @click="modalSLAEntregaCidade(data)">
                  <span class="text-dark">
                    {{ data.id }}
                  </span>
                </h5>
              </td>
              <td>
                <h5 class="font-size-14 text-truncate">
                  <span class="text-dark">
                    {{ data.cidade }}
                  </span>
                </h5>
              </td>
              <td>
                <h5 class="font-size-14 text-truncate">
                  <span class="text-dark">
                    {{ data.estado }}
                  </span>
                </h5>
              </td>
              <td>
                <h5 class="font-size-14 text-truncate">
                  <span class="text-dark">
                    {{ data.ibgecodigo }}
                  </span>
                </h5>
              </td>
              <td>
                <div class="button-items">
                  <b-button variant="outline-danger" @click="deletarcidadesla(data.id)" v-if="data.id">
                    <i class="mdi mdi-trash-can d-block font-size-16"></i>
                  </b-button>
                  <b-button variant="outline-danger" @click="modalSLAEntregaCidade(data)" v-else disabled>
                    <i class="mdi mdi-trash-can d-block font-size-16"></i>
                  </b-button>
                </div>
              </td>
            </tr>

            </tbody>
          </table>
          <br/>
          <b-button type="submit" class="ms-1 gap-5" @click="modalSLAEntregaCidade">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Adicionar cidade
          </b-button>
        </div>
      </div>
      <br/>
      <div class="mb-3 gap-5">
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarSlaEntrega">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Salvar
        </b-button>
      </div>
    </b-modal>

    <b-modal size="lg" title="SLA de Cidade" v-model="showModalSlaEntregaCidade" hide-footer>
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start gap-5">  
              <multiselect
                v-model="cidadeSelecionadaSLA"
                       placeholder="Pesquisar Cidade"
                       @search-change="pesqCidadeSLA"
                       :options="cidadesDataSLA"
                       :searchable="true"
                       :multiple="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="id"
              >
                <template #selection="{ values }">
                  {{ values }}
                </template>
                
                <template #option="{ option }">
                  <span>{{ option.descricao }} - {{ option.estado }}</span>
                </template>
                
              </multiselect>
            </div>
            <b-button type="submit" variant="success" class="ms-1 gap-5" @click="AdicionarCidade">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Adicionar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal size="lg" title="Consultar CEP" v-model="showModalConsCEP" hide-footer>

      <div class="row" v-if="loadingDadosCep">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingDadosCep">
        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Endereço</span>
              <b-form-checkbox
                  v-model="consCnpjImpEndereco"
                  switch>
                {{ consCnpjEndereco }}
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Complemento</span>
              <b-form-checkbox
                  v-model="consCnpjImpCompl"
                  switch>
                {{ consCnpjCompl }}
              </b-form-checkbox>
            </div>
          </div>

        </div>


        <div class="row">

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Bairro</span>
              <b-form-checkbox
                  v-model="consCnpjImpBairro"
                  switch>
                {{ consCnpjBairro }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Cidade</span>
              <b-form-checkbox
                  v-model="consCnpjImpCidade"
                  switch>
                {{ consCnpjCidade }}
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Estado</span>
              <b-form-checkbox
                  v-model="consCnpjImpEstado"
                  switch>
                {{ consCnpjEstado }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div v-if="!loadingEmpresa && emprePermisData">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalConsCEP = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarImpCep">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>

    </b-modal>


    <b-modal size="xl" title="Detalhes Endereço" v-model="showModalEndereco" centered hide-footer>
      <div>

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <GoogleMap
                  api-key="AIzaSyB25V1gifCD11H_PsrJyj-eh8xL9XtTbko"
                  :center="{ lat: -16, lng: -56 }"
                  :zoom="4.5"
                  style="height: 600px">
                <Marker
                    v-for="(m, index) in markers"
                    :options="markerOptions"
                    :key="index"
                    :position="m.position"
                    :clickable="true"
                    :draggable="true"
                    @click="center = m.position"
                ></Marker>
              </GoogleMap>
            </div>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalEndereco = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

        </div>
      </div>

    </b-modal>


    <b-modal title="Atualizar Arquivo de Logomarca" v-model="showModalAtuLogo" hide-footer>
      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="tipoestab">Tipo de Logomarca</label>
            <select
                id="tipoestab"
                v-model="tipoUpload"
                class="form-control">
              <option value="white">Tema Claro</option>
              <option value="black">Tema Escuro</option>
              <option value="jpgdanfe">Danfe (JPG)</option>
            </select>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">

      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAtuLogo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal v-model="showModalCertDigital" size="lg" centered hide-footer hide-header body-class="p-4">
      <div class="bg-success p-3 rounded-3 mb-4">
        <div class="d-flex align-items-center">
          <div>
            <h4 class="text-white mb-0 fw-bold">
              <icon class="mdi mdi-certificate me-2"></icon>
              Certificado Digital
            </h4>
            <p class="text-white mb-0">Upload e Configuração de Certificado</p>
          </div>
          <div class="text-end ms-auto">
            <button type="button" class="btn-close btn-close-white" @click="showModalCertDigital = false"></button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-5 mb-3">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label class="form-label fw-bold" for="tipocert">Tipo Certificado</label>
              <select
                  id="tipocert"
                  v-model="empreCertDigData.tipo"
                  class="form-control rounded-0">
                <option value="A1">A1</option>
                <option value="A3">A2</option>
                <option value="A4">A3</option>
              </select>
            </div>

            <div class="col-md-12 mb-3">
              <label class="form-label fw-bold" for="manifest">Manifestação</label>
              <select
                  id="manifest"
                  v-model="empreCertDigData.manifest"
                  class="form-control rounded-0">
                <option value="100">100 - Desativado</option>
                <option value="101">101 - Simples</option>
                <option value="102">102 - Completa</option>
              </select>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold" for="senhacert">Senha</label>
              <input
                  id="senhacert"
                  type="password"
                  v-model="empreCertDigData.senha"
                  class="form-control rounded-0"
                  placeholder="******">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label fw-bold" for="validadecert">Validade</label>
              <input
                  id="validadecert"
                  type="date"
                  v-model="empreCertDigData.validade"
                  class="form-control rounded-0">
            </div>
          </div>
        </div>

        <div class="col-md-7">
          <h5 class="font-size-14 text-uppercase fw-bold text-muted mb-3">
            <i class="mdi mdi-cloud-upload-outline me-2"></i>Upload do Arquivo
          </h5>
          <DropZone @change="selectedFile" />
          <div class="mt-3" v-if="dropzoneFile.name">
            <div class="d-flex align-items-center justify-content-between bg-soft-success p-3 rounded">
              <div class="d-flex align-items-center">
                <i class="mdi mdi-file-check-outline text-success font-size-20 me-2"></i>
                <span class="text-success fw-medium">{{ dropzoneFile.name }}</span>
              </div>
              <i 
                class="mdi mdi-close text-danger font-size-20" 
                style="cursor: pointer;"
                @click="dropzoneFile = ''"
                title="Remover arquivo">
              </i>
            </div>
          </div>
          <div v-if="submittedAnexo && !dropzoneFile.name" class="mt-2">
            <span class="text-danger font-size-12">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="text-end mt-4 border-top pt-3">
        <b-button variant="light" @click="cancelaCertDig" class="rounded-0 px-4 me-2">
          Cancelar
        </b-button>
        <b-button variant="success" class="rounded-0 px-4 shadow-sm" @click="confCertDig">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Confirmar
        </b-button>
      </div>
    </b-modal>



    <b-modal title="Detalhes Endereço (WMS)" v-model="showModalWmsEndereco" centered hide-footer>


      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Endereço ou parte do endereço preferencial de baixa de estoque</span>
          <div class="mb-3">
            <label for="wmsEnderecoSel">Endereço</label>
            <input
                id="wmsEnderecoSel"
                v-model="wmsEnderecoSel"
                type="text"
                class="form-control"
                placeholder="(exp.: A.001.1.1, A.001 ou A)"/>
          </div>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalWmsEndereco = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarWmsEndereco">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>

    </b-modal>


    <b-modal  
      size="lg"
      v-model="showFormToken" 
      centered 
      hide-footer
      hide-header
      body-class="p-4"
    >
      
      <div class="p-3 rounded-3 mb-4" :class="hubClassInfo.bg">
        <div class="d-flex align-items-center">
          <div>
            <h4 class="text-white mb-0 fw-bold">
              <i :class="['mdi', hubClassInfo.icon]"></i>
              {{ hubClassInfo.label }}
            </h4>
            <p class="text-white mb-0">
              {{ empreTokemData.id != null ? `Editar Token (${ empreTokemData.id })` : 'Configurar Novo Token' }}
            </p>
          </div>
          <button type="button" class="btn btn-link text-white ms-auto p-0 font-size-24" @click="showFormToken = false; triggerHubSelection('token')" title="Voltar">
            <i class="mdi mdi-reply"></i>
          </button>
        </div>
      </div>

      <div class="p-4 bg-light bg-opacity-50">
        <div class="row" v-if="loadingEmprTokemData">
           <div class="col-12 text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
        </div>

        <form class="needs-validation" v-if="!loadingEmprTokemData">
          <div class="mb-4">
            <h5 class="font-size-14 mb-3 text-uppercase fw-bold text-muted border-bottom pb-2">
              <i class="mdi mdi-information-outline me-1"></i> Identificação
            </h5>
            <div class="row">
              <div class="col-sm-6">
                <div class="mb-3">
                  <label class="form-label" for="hub">Hub <span class="text-danger">*</span></label>
                  <Multiselect
                      id="hub"
                      v-model="empreTokemData.hub"
                      :options="filteredHubs"
                      mode="single"
                      placeholder="Selecione um Hub"
                      :searchable="true"
                      :close-on-select="true"
                      label="label"
                      valueProp="value"
                      :class="{'is-invalid': !empreTokemData.hub}"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label class="form-label" for="validade">Validade (Dias)</label>
                  <input
                      id="validade"
                      v-model="empreTokemData.validade"
                      type="number"
                      class="form-control rounded-0 bg-light"
                      placeholder="Validade"
                      readonly
                      />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="font-size-14 mb-3 text-uppercase fw-bold text-muted border-bottom pb-2">
              <i class="mdi mdi-key-outline me-1"></i> Credenciais principais
            </h5>
            <div class="row">
              <div class="col-sm-12" v-if="empreTokemData.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="token">Token / API Key</label>
                  <input id="token" v-model="empreTokemData.token" type="text" class="form-control rounded-0" placeholder="Token de acesso"/>
                </div>
              </div>
              
              <div class="col-sm-6" v-if="['bancaria', 'erp', 'marketplace'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="cliid">Client ID</label>
                  <input id="cliid" v-model="empreTokemData.cliid" type="text" class="form-control rounded-0" placeholder="Insira o Client ID"/>
                </div>
              </div>
              <div class="col-sm-6" v-if="['bancaria', 'erp', 'marketplace'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="clisecret">Client Secret</label>
                  <input id="clisecret" v-model="empreTokemData.clisecret" type="text" class="form-control rounded-0" placeholder="Insira o Client Secret"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="empreTokemData.hub_class === 'transp'">
                <div class="mb-3">
                  <label class="form-label" for="transp_cnpj">CNPJ Transportadora</label>
                  <input id="transp_cnpj" v-model="empreTokemData.transp_cnpj" type="text" class="form-control rounded-0" v-maska="'##.###.###/####-##'"/>
                </div>
              </div>
              
              <div class="col-sm-12" v-if="empreTokemData.hub_class === 'transp'">
                <div class="mb-3">
                  <label class="form-label" for="token_transp">Token (ou API Key)</label>
                  <input id="token_transp" v-model="empreTokemData.token" type="text" class="form-control rounded-0" placeholder="Token"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="['transp', 'tms'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="login">Login</label>
                  <input id="login" v-model="empreTokemData.login" type="text" class="form-control rounded-0" placeholder="Login"/>
                </div>
              </div>
              <div class="col-sm-6" v-if="['transp', 'tms'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="senha">Senha</label>
                  <input id="senha" v-model="empreTokemData.senha" type="password" class="form-control rounded-0" placeholder="Senha"/>
                </div>
              </div>

              <div class="col-sm-12" v-if="['bancaria', 'erp', 'marketplace'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="actoken">Access Token</label>
                  <textarea id="actoken" v-model="empreTokemData.actoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Gerado automaticamente"></textarea>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="rftoken">Refresh Token</label>
                  <textarea id="rftoken" v-model="empreTokemData.rftoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Gerado automaticamente"></textarea>
                </div>
              </div>

              <div class="col-sm-6" v-if="['erp', 'marketplace'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="codloja">Código Loja</label>
                  <input id="codloja" v-model="empreTokemData.codloja" type="text" class="form-control rounded-0" placeholder="Ex: 12345"/>
                </div>
              </div>
              
              <div class="col-sm-12" v-if="['bancaria', 'transp', 'tms'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="urlapi">URL Base API</label>
                  <input id="urlapi" v-model="empreTokemData.urlloja" type="text" class="form-control rounded-0" placeholder="https://api.exemplo.com"/>
                </div>
              </div>
              
              <div class="col-sm-12" v-if="['erp', 'marketplace'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="urlloja">URL API Loja</label>
                  <input id="urlloja" v-model="empreTokemData.urlloja" type="text" class="form-control rounded-0" placeholder="https://loja.exemplo.com/api"/>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="font-size-14 mb-3 text-uppercase fw-bold text-muted border-bottom pb-2">
              <i class="mdi mdi-plus-circle-outline me-1"></i> Opcional
            </h5>
            <div class="row">
              <div class="col-sm-12" v-if="empreTokemData.hub === 'CORREIOS'">
                <div class="mb-3">
                  <label class="form-label" for="status_contrato">Status Contrato</label>
                  <textarea id="status_contrato" v-model="empreTokemData.rftoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Status do contrato"></textarea>
                </div>
              </div>

              <div class="col-sm-6" v-if="['transp', 'erp', 'marketplace', 'tms'].includes(empreTokemData.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="codadmin">Código Administrativo</label>
                  <input id="codadmin" v-model="empreTokemData.codadmin" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                </div>
              </div>
              
              <div class="col-sm-6" v-if="empreTokemData.hub_class === 'transp'">
                <div class="mb-3">
                   <label class="form-label" for="codcliente">Código Cliente</label>
                   <input id="codcliente" v-model="empreTokemData.codloja" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="empreTokemData.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="tms_cliid">Client ID</label>
                  <input id="tms_cliid" v-model="empreTokemData.cliid" type="text" class="form-control rounded-0" placeholder="Opcional"/>
                </div>
              </div>
              
              <div class="col-sm-6" v-if="empreTokemData.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="tms_clisecret">Client Secret</label>
                  <input id="tms_clisecret" v-model="empreTokemData.clisecret" type="text" class="form-control rounded-0" placeholder="Opcional"/>
                </div>
              </div>

              <div class="row" v-if="['erp', 'marketplace'].includes(empreTokemData.hub_class)">
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="opt_login">Login</label>
                      <input id="opt_login" v-model="empreTokemData.login" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="opt_senha">Senha</label>
                      <input id="opt_senha" v-model="empreTokemData.senha" type="password" class="form-control rounded-0" placeholder="Caso exista"/>
                    </div>
                  </div>
              </div>

              <div v-if="empreTokemData.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="tms_actoken">Access Token</label>
                  <textarea id="tms_actoken" v-model="empreTokemData.actoken" rows="2" class="form-control rounded-0" placeholder="Opcional"></textarea>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="tms_rftoken">Refresh Token</label>
                  <textarea id="tms_rftoken" v-model="empreTokemData.rftoken" rows="2" class="form-control rounded-0" placeholder="Opcional"></textarea>
                </div>
              </div>

              <div class="col-sm-12" v-if="empreTokemData.hub_class === 'bancaria'">
                <div class="mb-3">
                  <label class="form-label d-flex align-items-center">
                    Mensagem de Instrução Boleto
                    <i class="mdi mdi-help-circle-outline ms-2 font-size-18 text-primary" @click="showInstrucoesBoleto" title="Clique para ver instruções" style="cursor: pointer;"></i>
                  </label>

                  <div class="col-sm-12" v-if="empreTokemData.hub_class === 'bancaria'">
                    <div class="row">
                        <div class="col-sm-3 me-2 border-end">
                            <div class="mb-3">
                                <div class="d-flex align-items-center mb-2">
                                    <label class="form-label mb-0 me-2" for="juros_valor">Juros</label>
                                    <input type="checkbox" class="form-check-input" v-model="empreTokemData.juros_ativo">
                                </div>
                                <input id="juros_valor" type="text" v-model="empreTokemData.juros" class="form-control rounded-0" :disabled="!empreTokemData.juros_ativo" placeholder="0.00">
                            </div>
                        </div>
                        <div class="row col-sm-6 border-end me-2">
                          <div class="col-sm-6 border-end">
                              <div class="mb-3">
                                  <div class="d-flex align-items-center mb-2">
                                      <label class="form-label mb-0 me-2" for="multapj_valor">Multa PJ</label>
                                      <input type="checkbox" class="form-check-input" v-model="empreTokemData.multapj_ativo">
                                  </div>
                                  <input id="multapj_valor" type="text" v-model="empreTokemData.multapj" class="form-control rounded-0" :disabled="!empreTokemData.multapj_ativo" placeholder="0.00">
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="mb-3">
                                  <div class="d-flex align-items-center mb-2">
                                      <label class="form-label mb-0 me-2" for="multapf_valor">Multa PF</label>
                                      <input type="checkbox" class="form-check-input" v-model="empreTokemData.multapf_ativo">
                                  </div>
                                  <input id="multapf_valor" type="text" v-model="empreTokemData.multapf" class="form-control rounded-0" :disabled="!empreTokemData.multapf_ativo" placeholder="0.00">
                              </div>
                          </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="mb-3">
                                <div class="d-flex align-items-center mb-2">
                                    <label class="form-label mb-0 me-2" for="desconto_valor">Desconto</label>
                                    <input type="checkbox" class="form-check-input" v-model="empreTokemData.desconto_ativo">
                                </div>
                                <input id="desconto_valor" type="text" v-model="empreTokemData.desconto" class="form-control rounded-0" :disabled="!empreTokemData.desconto_ativo" placeholder="0.00">
                            </div>
                        </div>
                    </div>
                  </div>

                  <div class="row my-2">
                    <div class="col-sm-6">
                      <label class="form-label small text-muted fw-bold">Instruções para Pessoa Jurídica (PJ)</label>
                      <textarea id="instrucoes_boleto_pj" v-model="instrucoesBoletoPJDisplay" rows="4" class="form-control rounded-0" placeholder="Mensagem 1 (ex: Juros de [$juros] ao dia)&#10;Mensagem 2 (ex: Multa de [$multa] após vencimento)&#10;Mensagem 3 (ex: Desconto de [$desconto] até vencimento)"></textarea>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label small text-muted fw-bold">Instruções para Pessoa Física (PF)</label>
                      <textarea id="instrucoes_boleto_pf" v-model="instrucoesBoletoPFDisplay" rows="4" class="form-control rounded-0" placeholder="Mensagem 1 (ex: Juros de [$juros] ao dia)&#10;Mensagem 2 (ex: Multa de [$multa] após vencimento)&#10;Mensagem 3 (ex: Desconto de [$desconto] até vencimento)"></textarea>
                    </div>
                  </div>

                  <div class="mt-2 p-2 bg-warning bg-opacity-50 border text-dark small rounded" v-if="previewInstrucoesBoletoPJ || previewInstrucoesBoletoPF">
                    <strong>Preview de Mensagens de Instrução:</strong><hr class="my-1">
                    <div class="row">
                      <div class="col-sm-6 border-end" v-if="previewInstrucoesBoletoPJ">
                        <strong>Pessoa Jurídica (PJ):</strong><br>
                        <span v-html="previewInstrucoesBoletoPJ"></span>
                      </div>
                      <div class="col-sm-6" v-if="previewInstrucoesBoletoPF">
                        <strong>Pessoa Física (PF):</strong><br>
                        <span v-html="previewInstrucoesBoletoPF"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end border-top pt-4">
            <b-button variant="light" @click="showFormToken = false" class="rounded-0 px-4 me-2">
              <i class="bx bx-block font-size-16 align-middle me-2"></i> Cancelar
            </b-button>
            <b-button variant="outline-warning" @click="validarToken" v-if="empreTokemData.hub === 'CORREIOS'" class="rounded-0 px-4 me-2">
              <i class="bx bx-search font-size-16 align-middle me-2"></i> Validar Token
            </b-button>
            <b-button type="button" variant="success" class="rounded-0 px-4 shadow-sm" @click="confToken(false)">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Confirmar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal  
      size="lg"
      v-model="showFormEquivalence" 
      centered 
      hide-footer
      hide-header
      body-class="p-4"
    >
      <div class="p-3 rounded-3 mb-4" :class="hubClassInfo.bg">
        <div class="d-flex align-items-center">
          <div>
            <h4 class="text-white mb-0 fw-bold">
              <i :class="['mdi', hubClassInfo.icon]"></i>
              {{ hubClassInfo.label }}
            </h4>
            <p class="text-white mb-0">
              {{ equivalenceEditing.id != null ? `Editar Equivalência (${ equivalenceEditing.id })` : 'Configurar Nova Equivalência' }}
            </p>
          </div>
          <button type="button" class="btn btn-close btn-close-white ms-auto p-0 font-size-24" @click="showFormEquivalence = false"></button>
        </div>
      </div>

      <div class="p-4 bg-light bg-opacity-50">
        <div class="row" v-if="loadingEmprTokemData">
           <div class="col-12 text-center py-5">
            <b-spinner variant="primary"></b-spinner>
          </div>
        </div>

        <form class="needs-validation" v-if="!loadingEmprTokemData">
          <div class="mb-4">
            <div class="row align-items-end">
              <div class="col-sm-6">
                <div class="mb-3">
                  <label class="form-label" for="equiv_hub">Hub <span class="text-danger">*</span></label>
                  <Multiselect
                      id="equiv_hub"
                      v-model="empreTokemData.hub"
                      :options="filteredHubs"
                      mode="single"
                      placeholder="Selecione um Hub"
                      :searchable="true"
                      :close-on-select="true"
                      label="label"
                      valueProp="value"
                      :class="{'is-invalid': !empreTokemData.hub}"
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <b-button 
                    variant="outline-primary" 
                    class="rounded-0 w-100" 
                    @click="showFormEquivalenceToken = true; equivalenceEditing = { hub_class: empreTokemData.hub_class }"
                    :disabled="empreTokemData.id == null"
                  >
                    <i class="bx bx-plus font-size-16 align-middle me-2"></i> Novo Token
                  </b-button>
                </div>
              </div>
            </div>

            <div v-if="empreTokemData.id == null" class="alert alert-info border-0 rounded-0 d-flex align-items-center mb-0" role="alert">
              <i class="mdi mdi-information-outline font-size-18 me-2"></i>
              <span>Salve a equivalência antes de inserir um token.</span>
            </div>
          </div>

          <div class="table-responsive bg-white shadow-sm mb-4">
            <h5 class="font-size-14 p-3 mb-0 bg-white border-bottom fw-bold text-muted text-uppercase">Tokens Relacionados</h5>
            <table class="table align-middle mb-0 table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th>ID</th>
                  <th>Transp. CNPJ</th>
                  <th>Criado em</th>
                  <th>Validade (Access)</th>
                  <th>Validade (Refresh)</th>
                  <th class="text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in equivalenceTokens" :key="data.id">
                  <td class="fw-bold text-primary">#{{ data.id }}</td>
                  <td>{{ data.transp_cnpj }}</td>
                  <td>{{ formatDateTime(data.created_at) }}</td>
                  <td>{{ formatDateTime(data.actokenvalid) }}</td>
                  <td>{{ formatDateTime(data.rftokenvalid) }}</td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center gap-2">
                       <b-button size="sm" variant="outline-warning" @click="showFormEquivalenceToken = true; equivalenceEditing = data; equivalenceEditing.hub_class = empreTokemData.hub_class" class="rounded-0">
                        <i class="mdi mdi-pencil"></i>
                      </b-button>
                      <b-button size="sm" variant="outline-danger" @click="delEquivalenceToken(data.id)" class="rounded-0">
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </td>
                </tr>
                <tr v-if="equivalenceTokens.length === 0">
                  <td colspan="6" class="text-center py-4 text-muted">Nenhum token encontrado.</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="text-end border-top pt-4">
            <b-button variant="light" @click="showFormEquivalence = false" class="rounded-0 px-4 me-2">
              Cancelar
            </b-button>
            <b-button variant="success" class="rounded-0 px-4 shadow-sm" @click="confToken(true)">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Confirmar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal  
      size="lg"
      v-model="showFormEquivalenceToken" 
      centered 
      hide-footer
      hide-header
      body-class="p-4"
    >
      <div class="p-3 rounded-3 mb-4" :class="hubClassInfo.bg">
        <div class="d-flex align-items-center">
          <div>
            <h4 class="text-white mb-0 fw-bold">
              <i :class="['mdi', hubClassInfo.icon]"></i>
              {{ hubClassInfo.label }}
            </h4>
            <p class="text-white mb-0">
              {{ equivalenceEditing.id != null ? `Editar Token (${ equivalenceEditing.id })` : 'Configurar Novo Token' }}
            </p>
          </div>
          <button type="button" class="btn-close btn-close-white ms-auto" @click="showFormEquivalenceToken = false"></button>
        </div>
      </div>

      <div class="p-4 bg-light bg-opacity-50">
        <form class="needs-validation">
          <div class="mb-4">
            <h5 class="font-size-14 mb-3 text-uppercase fw-bold text-muted border-bottom pb-2">
              <i class="mdi mdi-key-outline me-1"></i> Credenciais do Token
            </h5>
            <div class="row">
              <div class="col-sm-12" v-if="equivalenceEditing.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="eq_token">Token / API Key</label>
                  <input id="eq_token" v-model="equivalenceEditing.token" type="text" class="form-control rounded-0" placeholder="Token de acesso"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="['bancaria', 'erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_cliid">Client ID</label>
                  <input id="eq_cliid" v-model="equivalenceEditing.cliid" type="text" class="form-control rounded-0" placeholder="Insira o Client ID"/>
                </div>
              </div>
              <div class="col-sm-6" v-if="['bancaria', 'erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_clisecret">Client Secret</label>
                  <input id="eq_clisecret" v-model="equivalenceEditing.clisecret" type="text" class="form-control rounded-0" placeholder="Insira o Client Secret"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="equivalenceEditing.hub_class === 'transp'">
                <div class="mb-3">
                  <label class="form-label" for="eq_transp_cnpj">CNPJ Transportadora</label>
                  <input id="eq_transp_cnpj" v-model="equivalenceEditing.transp_cnpj" type="text" class="form-control rounded-0" v-maska="'##.###.###/####-##'"/>
                </div>
              </div>

              <div class="col-sm-12" v-if="equivalenceEditing.hub_class === 'transp'">
                <div class="mb-3">
                  <label class="form-label" for="eq_token_transp">Token (ou API Key)</label>
                  <input id="eq_token_transp" v-model="equivalenceEditing.token" type="text" class="form-control rounded-0" placeholder="Token"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="['transp', 'tms'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_login">Login</label>
                  <input id="eq_login" v-model="equivalenceEditing.login" type="text" class="form-control rounded-0" placeholder="Login"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="['transp', 'tms'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_senha">Senha</label>
                  <input id="eq_senha" v-model="equivalenceEditing.senha" type="password" class="form-control rounded-0" placeholder="Senha"/>
                </div>
              </div>

              <div class="col-sm-12" v-if="['bancaria', 'erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_actoken">Access Token</label>
                  <textarea id="eq_actoken" v-model="equivalenceEditing.actoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Gerado automaticamente"></textarea>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="eq_rftoken">Refresh Token</label>
                  <textarea id="eq_rftoken" v-model="equivalenceEditing.rftoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Gerado automaticamente"></textarea>
                </div>
              </div>

              <div class="col-sm-6" v-if="['erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_codloja">Código Loja</label>
                  <input id="eq_codloja" v-model="equivalenceEditing.codloja" type="text" class="form-control rounded-0" placeholder="Ex: 12345"/>
                </div>
              </div>

              <div class="col-sm-12" v-if="['bancaria', 'transp', 'tms'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_urlapi">URL Base API</label>
                  <input id="eq_urlapi" v-model="equivalenceEditing.urlloja" type="text" class="form-control rounded-0" placeholder="https://api.exemplo.com"/>
                </div>
              </div>

              <div class="col-sm-12" v-if="['erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_urlloja">URL API Loja</label>
                  <input id="eq_urlloja" v-model="equivalenceEditing.urlloja" type="text" class="form-control rounded-0" placeholder="https://loja.exemplo.com/api"/>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4">
            <h5 class="font-size-14 mb-3 text-uppercase fw-bold text-muted border-bottom pb-2">
              <i class="mdi mdi-plus-circle-outline me-1"></i> Opcional
            </h5>
            <div class="row">
              <div class="col-sm-12" v-if="empreTokemData.hub === 'CORREIOS'">
                <div class="mb-3">
                  <label class="form-label" for="eq_status_contrato">Status Contrato</label>
                  <textarea id="eq_status_contrato" v-model="equivalenceEditing.rftoken" rows="2" readonly class="form-control rounded-0 bg-light" placeholder="Status do contrato"></textarea>
                </div>
              </div>

              <div class="col-sm-6" v-if="['transp', 'erp', 'marketplace', 'tms'].includes(equivalenceEditing.hub_class)">
                <div class="mb-3">
                  <label class="form-label" for="eq_codadmin">Código Administrativo</label>
                  <input id="eq_codadmin" v-model="equivalenceEditing.codadmin" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="equivalenceEditing.hub_class === 'transp'">
                <div class="mb-3">
                   <label class="form-label" for="eq_codcliente">Código Cliente</label>
                   <input id="eq_codcliente" v-model="equivalenceEditing.codloja" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="equivalenceEditing.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="eq_tms_cliid">Client ID</label>
                  <input id="eq_tms_cliid" v-model="equivalenceEditing.cliid" type="text" class="form-control rounded-0" placeholder="Opcional"/>
                </div>
              </div>

              <div class="col-sm-6" v-if="equivalenceEditing.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="eq_tms_clisecret">Client Secret</label>
                  <input id="eq_tms_clisecret" v-model="equivalenceEditing.clisecret" type="text" class="form-control rounded-0" placeholder="Opcional"/>
                </div>
              </div>

              <div class="row" v-if="['erp', 'marketplace'].includes(equivalenceEditing.hub_class)">
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="eq_opt_login">Login</label>
                      <input id="eq_opt_login" v-model="equivalenceEditing.login" type="text" class="form-control rounded-0" placeholder="Caso exista"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="mb-3">
                      <label class="form-label" for="eq_opt_senha">Senha</label>
                      <input id="eq_opt_senha" v-model="equivalenceEditing.senha" type="password" class="form-control rounded-0" placeholder="Caso exista"/>
                    </div>
                  </div>
              </div>

              <div v-if="equivalenceEditing.hub_class === 'tms'">
                <div class="mb-3">
                  <label class="form-label" for="eq_tms_actoken">Access Token</label>
                  <textarea id="eq_tms_actoken" v-model="equivalenceEditing.actoken" rows="2" class="form-control rounded-0" placeholder="Opcional"></textarea>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="eq_tms_rftoken">Refresh Token</label>
                  <textarea id="eq_tms_rftoken" v-model="equivalenceEditing.rftoken" rows="2" class="form-control rounded-0" placeholder="Opcional"></textarea>
                </div>
              </div>

              <div class="col-sm-12" v-if="equivalenceEditing.hub_class === 'bancaria'">
                 <div class="mb-3">
                  <label class="form-label d-flex align-items-center">
                    Mensagem de Instrução Boleto
                    <i class="mdi mdi-help-circle-outline ms-2 font-size-18 text-primary" @click="showInstrucoesBoleto" title="Clique para ver instruções" style="cursor: pointer;"></i>
                  </label>
                  <div class="row mb-3">
                    <div class="col-sm-3 me-2 border-end">
                        <div class="mb-3">
                            <div class="d-flex align-items-center mb-2">
                                <label class="form-label mb-0 me-2" for="eq_juros_valor">Juros</label>
                                <input type="checkbox" class="form-check-input" v-model="equivalenceEditing.juros_ativo">
                            </div>
                            <input id="eq_juros_valor" type="text" v-model="equivalenceEditing.juros" class="form-control rounded-0" :disabled="!equivalenceEditing.juros_ativo" placeholder="0.00">
                        </div>
                    </div>
                    <div class="row col-sm-6 border-end me-2">
                          <div class="col-sm-6 border-end">
                              <div class="mb-3">
                                  <div class="d-flex align-items-center mb-2">
                                      <label class="form-label mb-0 me-2" for="eq_multapj_valor">Multa PJ</label>
                                      <input type="checkbox" class="form-check-input" v-model="equivalenceEditing.multapj_ativo">
                                  </div>
                                  <input id="eq_multapj_valor" type="text" v-model="equivalenceEditing.multapj" class="form-control rounded-0" :disabled="!equivalenceEditing.multapj_ativo" placeholder="0.00">
                              </div>
                          </div>
                          <div class="col-sm-6">
                              <div class="mb-3">
                                  <div class="d-flex align-items-center mb-2">
                                      <label class="form-label mb-0 me-2" for="eq_multapf_valor">Multa PF</label>
                                      <input type="checkbox" class="form-check-input" v-model="equivalenceEditing.multapf_ativo">
                                  </div>
                                  <input id="eq_multapf_valor" type="text" v-model="equivalenceEditing.multapf" class="form-control rounded-0" :disabled="!equivalenceEditing.multapf_ativo" placeholder="0.00">
                              </div>
                          </div>
                    </div>
                    <div class="col-sm-2">
                         <div class="mb-3">
                            <div class="d-flex align-items-center mb-2">
                                <label class="form-label mb-0 me-2" for="eq_desconto_valor">Desconto</label>
                                <input type="checkbox" class="form-check-input" v-model="equivalenceEditing.desconto_ativo">
                            </div>
                            <input id="eq_desconto_valor" type="text" v-model="equivalenceEditing.desconto" class="form-control rounded-0" :disabled="!equivalenceEditing.desconto_ativo" placeholder="0.00">
                        </div>
                    </div>
                  </div>

                  <div class="row my-2">
                    <div class="col-sm-6">
                      <label class="form-label small text-muted fw-bold">Instruções para Pessoa Jurídica (PJ)</label>
                      <textarea id="eq_instrucoes_boleto_pj" v-model="instrucoesBoletoPJDisplayEquivalence" rows="4" class="form-control rounded-0" placeholder="Mensagem 1 (ex: Juros de [$juros] ao dia)&#10;Mensagem 2 (ex: Multa de [$multa] após vencimento)&#10;Mensagem 3 (ex: Desconto de [$desconto] até vencimento)"></textarea>
                    </div>
                    <div class="col-sm-6">
                      <label class="form-label small text-muted fw-bold">Instruções para Pessoa Física (PF)</label>
                      <textarea id="eq_instrucoes_boleto_pf" v-model="instrucoesBoletoPFDisplayEquivalence" rows="4" class="form-control rounded-0" placeholder="Mensagem 1 (ex: Juros de [$juros] ao dia)&#10;Mensagem 2 (ex: Multa de [$multa] após vencimento)&#10;Mensagem 3 (ex: Desconto de [$desconto] até vencimento)"></textarea>
                    </div>
                  </div>

                  <div class="mt-2 p-2 bg-warning bg-opacity-50 border text-dark small rounded" v-if="previewInstrucoesBoletoEquivalencePJ || previewInstrucoesBoletoEquivalencePF">
                    <strong>Preview de Mensagens de Instrução:</strong><hr class="my-1">
                    <div class="row">
                      <div class="col-sm-6 border-end" v-if="previewInstrucoesBoletoEquivalencePJ">
                        <strong>PJ:</strong><br>
                        <span v-html="previewInstrucoesBoletoEquivalencePJ"></span>
                      </div>
                      <div class="col-sm-6" v-if="previewInstrucoesBoletoEquivalencePF">
                        <strong>PF:</strong><br>
                        <span v-html="previewInstrucoesBoletoEquivalencePF"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-end border-top pt-4">
            <b-button variant="light" @click="showFormEquivalenceToken = false" class="rounded-0 px-4 me-2">
              Cancelar
            </b-button>
            <b-button variant="outline-warning" @click="validarToken" v-if="empreTokemData.hub === 'CORREIOS'" class="rounded-0 px-4 me-2">
              <i class="bx bx-search font-size-16 align-middle me-2"></i> Validar Token
            </b-button>
            <b-button type="button" variant="success" class="rounded-0 px-4 shadow-sm" @click="saveEquivalenceToken">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i> Confirmar
            </b-button>
          </div>
        </form>
      </div>
    </b-modal>


    <b-modal  size="lg"
              title="Criar novo Seguimento de Frete (Complementar)" v-model="showFormSegtoFrete" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">


              <div class="row">


                <div class="col-md-12">
                  <div class="mb-3">
                    <span>Seguimento de Frete (Complementar)</span>

                    <multiselect id="segtofrete"
                                 class="mt-2"
                                 @search-change="pesqFreteCota"
                                 @select="escolheuFreteCota"
                                 v-model="emprSegtoData.codigo"
                                 placeholder="Pesquisar seguimento"
                                 :options="dtListPesqFreteCota"
                                 :searchable="true"
                                 label="nome"
                                 track-by="nome"
                                 :style="submittedEmprSegto && !emprSegtoData.codigo ? 'border: 1px solid #f86c6b !important;' : ''"
                                 value-prop="codigo">
                      <template #option="slotProps">
                        <div class="row">
                          <div>
                                  <span class="text-info">
                                    {{ slotProps.option.codigo }}
                                  </span>
                            <span class="mx-4" >

                                  </span>
                          </div>
                          <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                          <span class="mx-4" >
                                </span>
                          <span class="mx-4" >
                                </span>
                          <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

                        </div>
                      </template>
                    </multiselect>
                    <div v-if="submittedEmprSegto && !emprSegtoData.codigo">
                      <span class="text-danger font-size-11">Campo Seguimento obrigatório, favor preencher.</span>
                    </div>

                  </div>
                </div>

              </div>


              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormSegtoFrete = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confSegtoFrete">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>





    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>


    <b-modal  size="lg"
              :title="emprParamData.id != null ? `Editar Parâmetro (${ emprParamData.id })` : 'Criar Novo Parâmetro'"
              v-model="showFormEmprParam" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="valor">Valor</label>
                    <select id="valor" v-model="emprParamData.valor" class="form-control"
                            :disabled="emprParamData.id != null">
                      <option value="COTA_ELK">Calculador de fretes passar pelo ElasticSearch</option>
                      <option value="COD_COTA_CORR">Código de serviço default para cotação de Fretes nos Correios</option>
                      <option value="COTAAUTO">Cotação automática de frete na entrada de notas</option>
                      <option value="CTE_CONC_AUTO">Conciliação automática na inserção de CTE</option>
                      <option value="CTE_CONC_PRZ_MOV">Na Conciliação de CTE atualizar prazo da mov</option>
                      <option value="CONF_PARC_FIN">Conferencia parcial como status finalizador</option>
                      <option value="DT_FECHA_ESTQ">Data de fechamento do estoque</option>
                      <option value="INSERT_TOMADOR">Insert empresa tomadora do frete</option>
                      <option value="NOVO_FLUXO_SALDO">Novo fluxo de saldo</option>
                      <option value="LINK_RASTREIO">Link para rastreio de entregas</option>
                      <option value="GERA_AUTO_OS_API_ORCAMENTO">Criação de OS de daída ao criar um orçamento via API</option>
                      <option value="ADICIONA_VOLUME_ROMANEIO">Adiciona automaticamente o volume no romaneio baseado na nota fiscal</option>
                      <option value="ARQ_PROJ_VISIO">Id do arquivo (gDrive) de gerenciamento de projetos para download</option>
                      <option value="FORCE_TRANSF_WMSROMA">Transfere OS entre romaneios (mesmo finalizado)</option>
                      <option value="GERA_ROMA_ORCTO">Gerar romaneio com informações de orçamento</option>
                      <option value="IMPR_ETIQ_ORCTO">Impressão tipo "mini-danfe" de orçamento</option>
                      <option value="ADD_CAMPANHA">Adicionar Logos de campanhas aos pedidos/Orçamentos</option>
                      <option value="FORCE_ADD_ITEMS">Inserir itens mesmo após a confirmação de um Pedido</option>
                      <option value="NOT_BUSCA_EAN">Não buscar EAN para POST de Orçamentos API</option>
                      <option value="NAO_CADASTRAR_PROD_AUTO">Não adicionar produtos automaticamente ao carregar uma nota fiscal</option>
                      <option value="LOTE_WMSOS">Informar lote no estágio de "conferência"</option>
                      <option value="DESAB_LOTES" disabled>Desabilitar lotes de TODOS os produtos</option>
                      <option value="GERA_OS_PDF_RELATORIO">Habilitar impressão de PDF ao conferir OS saida</option>
                      <option value="GERAR_FINANC_FRETE">Geração de financeiro para frete</option>
                      <option value="NOVO_REGER_SALDO">Regerar saldo(novo)</option>
                      <option value="DELETE_PRODUTOSALDO">Deleção de Histórico de produto</option>
                      <option value="EDIT_DOCCOB">Editar informações de Doccob</option>
                      <option value="USA_WPP_CAD_CLIENTE">Utilizar apenas número do cadastro de cliente para mensagens
                        WhatsApp</option>
                      <option value="NAO_SOLICITA_COLETA_AUTO">Não solicitar coleta automaticamente ao finalizar romaneio</option>
                      <option value="NAO_FINALIZA_WMSROMANEIO">Não finalizar automaticamente romaneios quando todos os volumes forem lidos</option>
                      <option value="TRAVA_ADD_REMOV_WMSROMANEIO">Restringir adição e remoção de documentos/volumes a usuários admin</option>
                    </select>
                    <div v-if="submittedEmprParam && !emprParamData.valor" class="invalid-feedback">
                      <span>Campo valor obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="emprParamData && emprParamData.valor === 'DT_FECHA_ESTQ'">
                  <div class="mb-3">
                    <label for="data">Data</label>
                    <input
                        id="data"
                        v-model="emprParamData.dataF"
                        type="date"
                        class="form-control"
                        placeholder="Data"/>
                  </div>
                </div>


                <div class="col-md-6" v-if="emprParamData && emprParamData.valor === 'COD_COTA_CORR'">
                  <div class="mb-3">
                    <label for="codigo">Código</label>
                    <input
                        id="codigo"
                        v-model="emprParamData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código"/>
                  </div>
                </div>


                <div class="col-md-6"
                  v-if="emprParamData && (emprParamData.valor === 'LINK_RASTREIO' || emprParamData.valor === 'ARQ_PROJ_VISIO' || emprParamData.valor === 'USA_WPP_CAD_CLIENTE')">
                  <div class="mb-3">
                    <label for="descricao">Descrição</label>
                    <input
                        id="descricao"
                        v-model="emprParamData.descricao"
                        type="text"
                        class="form-control"
                        placeholder="Descrição"/>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormEmprParam = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confEmprParam">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>




    <b-modal  size="lg"
              :title="emprOrigemData.id != null ? `Editar Origem Cotação (${ emprOrigemData.id })` : 'Criar Nova Origem Cotação'"
              v-model="showFormOrigem" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">

              <div class="row mb-2">

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="cep">CEP</label>
                    <div class="position-relative">
                      <input
                          id="cep"
                          v-maska="'##.###-###'"
                          v-model="emprOrigemData.cep"
                          type="text"
                          class="form-control"
                          :class="{'is-invalid': submittedEmprOrigem && !emprOrigemData.cep}"
                          placeholder="CEP"/>
                      <div v-if="submittedEmprOrigem && !emprOrigemData.cep"
                           class="invalid-feedback">
                        <span v-if="submittedEmprOrigem && !emprOrigemData.cep">Campo CEP obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="rua">Endereço</label>
                    <div class="position-relative">
                      <input
                          id="rua"
                          v-model="emprOrigemData.rua"
                          type="text"
                          class="form-control"
                          placeholder="Endereço"/>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="numero">Número</label>
                    <input
                        id="numero"
                        v-model="emprOrigemData.numero"
                        type="text"
                        class="form-control"
                        placeholder="Número"/>
                  </div>
                </div>

              </div>


              <div class="row mb-2">

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="bairro">Bairro</label>
                    <input
                        id="bairro"
                        v-model="emprOrigemData.bairro"
                        type="text"
                        class="form-control"
                        placeholder="Bairro"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="compl">Complemento</label>
                    <input
                        id="compl"
                        v-model="emprOrigemData.compl"
                        type="text"
                        class="form-control"
                        placeholder="Complemento"/>
                  </div>
                </div>

              </div>

              <div class="row mb-2">


                <div class="col-md-6">
                  <div class="mb-3">

                    <span class="font-size-13">Cidade </span>
                    <multiselect id="inputCidade"
                                 @search-change="pesqCidade"
                                 @select="escolheuCidade"
                                 v-model="emprOrigemData.codmun"
                                 placeholder="Selecionar cidade"
                                 :options="dtListPesqCidade"
                                 :searchable="true"
                                 label="descricao"
                                 track-by="descricao"
                                 value-prop="codigo"
                                 class="mt-2">
                      <template #option="slotProps">
                        <div style="min-width: 25%;">
                              <span class="text-info">
                                {{ slotProps.option.estado }}
                              </span>
                        </div>
                        <div style="min-width: 300px;">
                              <span class="mx-4" >
                                {{ slotProps.option.descricao }}
                              </span>
                        </div>
                      </template>
                    </multiselect>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="estado">Estado</label>
                    <input
                        id="estado"
                        v-model="emprOrigemData.estado"
                        type="text"
                        class="form-control"
                        placeholder="Estado"/>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormOrigem = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confEmprOrigem">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal  size="lg"
              :title="emprOrigemData.id != null ? `Editar Regra de Frete (${ regraFreteData.id })` : 'Criar Nova Regra de Frete'"
              v-model="showFormRegraFrete" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">
            <form class="needs-validation">

              <div class="row mb-2">


                <div class="col-sm-12">
                  <div class="mb-3">
                    <label for="tipo">Tipo de Regra</label>
                    <select
                        id="tipo"
                        v-model="regraFreteData.tipo"
                        class="form-control"
                        :class="{'is-invalid': submittedRegraFrete && !regraFreteData.tipo}">
                      <option value="BLOQ_DEST_EST">Bloquear Estado de Destino</option>
                      <option value="FIX_DEST_EST">Fixar Estado de Destino</option>
                      <option value="API_MIN_PRC">Retornar cotação com menor preço (API)</option>
                      <option value="API_MIN_PRZ">Retornar cotação com menor prazo (API)</option>
                      <option value="API_MIN_PRZ_TOL">Retornar cotação com menor prazo -> x dias de tolerância (API)</option>
                      <option value="API_MIN_PRC_TOL">Retornar cotação com menor prazo -> % tolerância sobre valor (API)</option>
                    </select>
                    <div v-if="submittedRegraFrete && !regraFreteData.tipo" class="invalid-feedback">
                      <span>Campo tipo obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-sm-6" v-if="regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST'">
                  <div class="mb-3">
                    <label for="estadorefrete">Estado</label>
                    <select
                        id="estadorefrete"
                        v-model="regraFreteData.destino"
                        class="form-control"
                        :class="{'is-invalid': submittedRegraFrete && !regraFreteData.destino && (regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST')}">
                      <option value="AC">Acre</option>
                      <option value="AL">Alagoas</option>
                      <option value="AP">Amapá</option>
                      <option value="AM">Amazonas</option>
                      <option value="BA">Bahia</option>
                      <option value="CE">Ceará</option>
                      <option value="ES">Espírito Santo</option>
                      <option value="GO">Goiás</option>
                      <option value="MA">Maranhão</option>
                      <option value="MT">Mato Grosso</option>
                      <option value="MS">Mato Grosso do Sul</option>
                      <option value="MG">Minas Gerais</option>
                      <option value="PA">Pará</option>
                      <option value="PB">Paraíba</option>
                      <option value="PR">Paraná</option>
                      <option value="PE">Pernambuco</option>
                      <option value="PI">Piauí</option>
                      <option value="RJ">Rio de Janeiro</option>
                      <option value="RN">Rio Grande do Norte</option>
                      <option value="RS">Rio Grande do Sul</option>
                      <option value="RO">Rondônia</option>
                      <option value="RR">Roraima</option>
                      <option value="SC">Santa Catarina</option>
                      <option value="SP">São Paulo</option>
                      <option value="SE">Sergipe</option>
                      <option value="TO">Tocantins</option>
                      <option value="DF">Distrito Federal</option>
                    </select>
                    <div v-if="submittedRegraFrete && !regraFreteData.destino && (regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST')" class="invalid-feedback">
                      <span>Campo estado obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST'">
                  <div class="mb-3">
                    <label for="cnpjtransp">CNPJ Transportadora</label>
                    <div class="position-relative">
                      <input
                          id="cnpjtransp"
                          v-model="regraFreteData.cnpjtransp"
                          type="text"
                          class="form-control"
                          :class="{'is-invalid': submittedRegraFrete && !regraFreteData.cnpjtransp && (regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST')}"
                          placeholder="CNPJ Transportadora"/>
                      <div v-if="submittedRegraFrete && !regraFreteData.cnpjtransp && (regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST')"
                           class="invalid-feedback">
                        <span v-if="submittedRegraFrete && !regraFreteData.cnpjtransp && (regraFreteData.tipo === 'BLOQ_DEST_EST' || regraFreteData.tipo === 'FIX_DEST_EST')">Campo CEP obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6" v-if="regraFreteData.tipo === 'API_MIN_PRC_TOL' || regraFreteData.tipo === 'API_MIN_PRZ_TOL'">
                  <div class="mb-3">
                    <label for="valor">Valor</label>
                    <div class="position-relative">
                      <input
                          id="valor"
                          v-model="regraFreteData.valor"
                          type="text"
                          class="form-control"
                          :class="{'is-invalid': submittedRegraFrete && !regraFreteData.valor && (regraFreteData.tipo === 'API_MIN_PRC_TOL' || regraFreteData.tipo === 'API_MIN_PRZ_TOL')}"
                          placeholder="Valor"/>
                      <div v-if="submittedRegraFrete && !regraFreteData.valor && (regraFreteData.tipo === 'API_MIN_PRC_TOL' || regraFreteData.tipo === 'API_MIN_PRZ_TOL')"
                           class="invalid-feedback">
                        <span v-if="submittedRegraFrete && !regraFreteData.valor && (regraFreteData.tipo === 'API_MIN_PRC_TOL' || regraFreteData.tipo === 'API_MIN_PRZ_TOL')">Campo Valor obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormRegraFrete = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confRegraFrete">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Upload Logo para acordos" v-model="showModalLogoCobranca" hide-footer>
      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalLogoCobranca = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="showModalLogoCobranca = false">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalHelp"
        id="showModalHelp"
        size="lg"
        title="Descrição das funcionalidades"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Tipo</th>
                    <th>Descrição</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListHelp" :key="data.id">
                    <td>{{data.tipo}}</td>
                    <td>{{data.descricao}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal
        id="modal-hub-selection"
        v-model="showHubSelectionModal"
        hide-footer
        centered
        size="lg"
        header-class="border-0 pb-0"
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
    >
      <div class="text-center p-4">
        <div class="mb-4">
          <h4 class="fw-bold">Escolha o Hub!</h4>
          <p class="text-muted font-size-15">
            Selecione a classe de hub que deseja configurar para continuar.
          </p>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-sm-4">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="selectedHubClass === 'bancaria' ? 'border-primary bg-soft-primary' : 'border-light'"
                @click="selectedHubClass = 'bancaria'"
            >
              <div class="card-body p-3">
                <div class="mb-2">
                  <i :class="['mdi', selectedHubClass === 'bancaria' ? 'mdi-check-circle text-primary' : 'mdi-circle-outline text-light', 'font-size-18 float-end']"></i>
                  <i class="mdi mdi-bank font-size-32 text-primary"></i>
                </div>
                <h6 class="fw-bold text-primary mb-1">Agencias Bancárias</h6>
                <p class="text-muted mb-0 font-size-11">Integrações com bancos e serviços financeiros.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="selectedHubClass === 'transp' ? 'border-success bg-soft-success' : 'border-light'"
                @click="selectedHubClass = 'transp'"
            >
              <div class="card-body p-3">
                <div class="mb-2">
                  <i :class="['mdi', selectedHubClass === 'transp' ? 'mdi-check-circle text-success' : 'mdi-circle-outline text-light', 'font-size-18 float-end']"></i>
                  <i class="mdi mdi-truck font-size-32 text-success"></i>
                </div>
                <h6 class="fw-bold text-success mb-1">Credenciais Transportador</h6>
                <p class="text-muted mb-0 font-size-11">Rastreio e cotação de fretes.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="selectedHubClass === 'erp' ? 'border-info bg-soft-info' : 'border-light'"
                @click="selectedHubClass = 'erp'"
            >
              <div class="card-body p-3">
                <div class="mb-2">
                  <i :class="['mdi', selectedHubClass === 'erp' ? 'mdi-check-circle text-info' : 'mdi-circle-outline text-light', 'font-size-18 float-end']"></i>
                  <i class="mdi mdi-application-cog font-size-32 text-info"></i>
                </div>
                <h6 class="fw-bold text-info mb-1">ERP terceiro</h6>
                <p class="text-muted mb-0 font-size-11">Sincronização com sistemas externos.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="selectedHubClass === 'marketplace' ? 'border-warning bg-soft-warning' : 'border-light'"
                @click="selectedHubClass = 'marketplace'"
            >
              <div class="card-body p-3">
                <div class="mb-2">
                  <i :class="['mdi', selectedHubClass === 'marketplace' ? 'mdi-check-circle text-warning' : 'mdi-circle-outline text-light', 'font-size-18 float-end']"></i>
                  <i class="mdi mdi-store font-size-32 text-warning"></i>
                </div>
                <h6 class="fw-bold text-warning mb-1">Marketplace</h6>
                <p class="text-muted mb-0 font-size-11">Vendas multicanal e plataformas de comércio.</p>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div
                class="card border-2 cursor-pointer h-100 selection-card"
                :class="selectedHubClass === 'tms' ? 'border-danger bg-soft-danger' : 'border-light'"
                @click="selectedHubClass = 'tms'"
            >
              <div class="card-body p-3">
                <div class="mb-2">
                  <i :class="['mdi', selectedHubClass === 'tms' ? 'mdi-check-circle text-danger' : 'mdi-circle-outline text-light', 'font-size-18 float-end']"></i>
                  <i class="mdi mdi-routes font-size-32 text-danger"></i>
                </div>
                <h6 class="fw-bold text-danger mb-1">TMS</h6>
                <p class="text-muted mb-0 font-size-11">Gerenciamento de transporte e logística avançada.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-2">
          <div class="col-sm-6">
            <b-button
                variant="light"
                size="lg"
                class="rounded-pill w-100"
                @click="showHubSelectionModal = false"
            >
              Cancelar
            </b-button>
          </div>
          <div class="col-sm-6">
            <b-button
                variant="primary"
                size="lg"
                class="rounded-pill shadow w-100"
                @click="confirmHubSelection"
                :disabled="!selectedHubClass"
            >
              Confirmar <i class="mdi mdi-check-bold ms-1"></i>
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>

<style>
.preserve-format {
  white-space: pre-wrap;
}

.cursor-pointer {
  cursor: pointer;
}
.selection-card {
  transition: all 0.3s ease;
  transform: translateY(0);
}

.selection-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.05) !important;
}

.bg-soft-primary { background-color: rgba(85, 110, 230, 0.1) !important; }
.bg-soft-success { background-color: rgba(52, 195, 143, 0.1) !important; }
.bg-soft-info { background-color: rgba(80, 165, 241, 0.1) !important; }
.bg-soft-warning { background-color: rgba(241, 180, 76, 0.1) !important; }
.bg-soft-danger { background-color: rgba(244, 106, 106, 0.1) !important; }
</style>
